import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** The root query type */
export type Query = {
  __typename?: 'Query';
  /** Aggregated ticket-sales summary across a filtered set of events */
  aggregatedEventSales: EventSalesAggregated;
  /** Get a single artist by ID */
  artist?: Maybe<Artist>;
  artists: Array<SearchResultArtist>;
  /** The cancellation of an event, polled for the outcome of cancelEvent; null if it was never canceled */
  canceledEvent?: Maybe<CanceledEvent>;
  /** The currently authenticated user and their capabilities */
  currentUser?: Maybe<Me>;
  /** Get a single customer by ID; null unless they have a completed order on the current account */
  customer?: Maybe<CustomerDetails>;
  /** Filtered list of customers with at least one completed order on the current account; returns 100 per page by default and at most 250 */
  customers: CustomerConnection;
  /** Default values set for a venue */
  defaultSet?: Maybe<DefaultSet>;
  /** List of discounts for an event */
  discounts?: Maybe<Array<Discount>>;
  /** Get a single email schedule */
  emailSchedule?: Maybe<EmailSchedule>;
  /** Returns a single event */
  event?: Maybe<Event>;
  /** List of event artists */
  eventArtists?: Maybe<Array<EventArtist>>;
  /** Find an artist settlement by ID */
  eventArtistSettlement?: Maybe<Settlement>;
  /** List an artist's non-archived settlements in an event group, oldest first */
  eventArtistSettlements: Array<Settlement>;
  eventGroupArtists: EventGroupArtistCollection;
  /** Returns paginated list of found events, according to parameters */
  events?: Maybe<EventSummaryConnection>;
  /** List of feature previews for an account */
  featurePreviews: Array<FeaturePreview>;
  /** Catalog of event categories, each with their subcategories, for the announce form pickers */
  genreCategories: Array<Category>;
  /** Catalog of event types for the announce form pickers */
  genreTypes: Array<Type>;
  /** List of labels for an account */
  labels: Array<Label>;
  /** Looker report embed link for the current user account */
  lookerReportLink?: Maybe<Scalars['String']['output']>;
  /** List of Looker reports available to the current user */
  lookerReports: Array<Report>;
  /**
   * Currently logged-in user information
   * @deprecated Use currentUser instead.
   */
  me?: Maybe<User>;
  /** The account's memos overlapping a date window, as a paginated connection */
  memos: MemoConnection;
  /** Returns the next hold number for the date */
  nextHoldNumber: Scalars['Int']['output'];
  /** Get a single offer sheet by ID */
  offerSheet?: Maybe<Sheet>;
  /** List of offer sheet templates for the current account */
  offerSheetTemplates?: Maybe<Array<Template>>;
  /** Get a single order by ID */
  order?: Maybe<OrderDetails>;
  /** Filtered list of orders */
  orders: OrderConnection;
  /** List of accounts associated with the logged-in user */
  organizations?: Maybe<Array<Organization>>;
  /** Whether WebAuthn / passkey sign-in is enabled on this deployment */
  passkeyLoginEnabled: Scalars['Boolean']['output'];
  /** Get a single seating chart */
  seatingChart?: Maybe<SeatingChart>;
  /** List of seating charts */
  seatingCharts?: Maybe<SeatingChartConnection>;
  /** Seats.io configuration for the current account */
  seatsIoConfig?: Maybe<SeatsIoConfig>;
  /** Full permission and allowance definition for a single team role */
  teamRoleDetails?: Maybe<TeamRoleDetails>;
  /** List of team roles for the current account */
  teamRoles: Array<TeamRole>;
  /** An event's tickets in display order, holds excluded */
  ticketBlueprints?: Maybe<Array<TicketBlueprint>>;
  /** Price a ticket that has not been saved, as the buyer would pay for it. Persists nothing */
  ticketPricingPreview?: Maybe<TicketPricingBreakdown>;
  /**
   * An event's ticket types, for the discount and presale pickers
   * @deprecated Use `ticketBlueprints`, which returns the same tickets as the full TicketBlueprint type
   */
  ticketTypes?: Maybe<Array<EventTicketType>>;
  /** Paginated list of user accounts (team members) for the current account */
  userAccounts: UserAccountConnection;
  /** List of venues for the current account, including each venue's default set */
  venues: Array<Venue>;
  /** A webhook subscription's delivery attempts, most recent first */
  webhookDeliveryAttempts: WebhookDeliveryAttemptConnection;
  /** A webhook subscription's change history, most recent first */
  webhookSubscriptionAuditLog: AuditLogEntryConnection;
  /** The current account's outbound webhook subscriptions */
  webhookSubscriptions: Array<WebhookSubscription>;
  /** A single widget configuration for the current account */
  widgetConfiguration?: Maybe<WidgetConfig>;
  /** List of widget configurations for the current account */
  widgetConfigurations: WidgetConfigConnection;
  /** List of will call email templates for an account */
  willCallEmailTemplates: Array<EmailTemplate>;
  /** Distinct ticket-holder recipients a will-call send reaches, optionally for one ticket type */
  willCallRecipientCount: Scalars['Int']['output'];
};


/** The root query type */
export type QueryAggregatedEventSalesArgs = {
  filter?: InputMaybe<EventSearchArguments>;
};


/** The root query type */
export type QueryArtistArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryArtistsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type */
export type QueryCanceledEventArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryCustomerArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type */
export type QueryDefaultSetArgs = {
  venueId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type */
export type QueryDiscountsArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryEmailScheduleArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryEventArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type */
export type QueryEventArtistsArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryEventArtistSettlementArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryEventArtistSettlementsArgs = {
  artistId: Scalars['ID']['input'];
  eventGroupId: Scalars['ID']['input'];
};


/** The root query type */
export type QueryEventGroupArtistsArgs = {
  eventGroupId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type */
export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: EventSearchArguments;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type */
export type QueryLookerReportLinkArgs = {
  reportId: Scalars['String']['input'];
};


/** The root query type */
export type QueryMemosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MemoSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type */
export type QueryNextHoldNumberArgs = {
  date: Scalars['ISO8601Date']['input'];
  roomId: Scalars['Int']['input'];
  venueId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryOfferSheetArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type */
export type QuerySeatingChartArgs = {
  eventId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type */
export type QuerySeatingChartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeChildCharts?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type */
export type QueryTeamRoleDetailsArgs = {
  roleId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryTicketBlueprintsArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryTicketPricingPreviewArgs = {
  ticketBlueprint: TicketBlueprintAttributes;
};


/** The root query type */
export type QueryTicketTypesArgs = {
  eventId: Scalars['Int']['input'];
};


/** The root query type */
export type QueryUserAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type */
export type QueryWebhookDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attemptedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  attemptedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
  topic?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type */
export type QueryWebhookSubscriptionAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId: Scalars['ID']['input'];
};


/** The root query type */
export type QueryWidgetConfigurationArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type */
export type QueryWidgetConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WidgetConfigSearchArguments>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrderingArgument>>;
};


/** The root query type */
export type QueryWillCallRecipientCountArgs = {
  eventId: Scalars['Int']['input'];
  ticketBlueprintId?: InputMaybe<Scalars['Int']['input']>;
};

export type EventSearchArguments = {
  /** Start date for searching events in iso8601 format, eg. 2025-06-01 */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** End date for searching events in iso8601 format, eg. 2025-06-11 */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** When true, the name filter also matches the event group's name (event name OR group name). No effect unless name is provided. */
  matchEventGroupName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by event name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter events by status; omit to include every status except deleted */
  state?: InputMaybe<Array<EventStateEnum>>;
  /** Filter by whether the event has tickets defined */
  ticketed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter events by venue */
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

/** Lifecycle status of an event */
export enum EventStateEnum {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Deleted = 'DELETED',
  Hold = 'HOLD'
}

/** Aggregated ticket-sales summary across a filtered set of events */
export type EventSalesAggregated = {
  __typename?: 'EventSalesAggregated';
  /** Aggregated sales figures */
  salesData: EventSales;
};

/** Aggregated ticket-sales figures for a set of events */
export type EventSales = {
  __typename?: 'EventSales';
  /** Number of tickets sold */
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  /** Total net sales amount */
  totalSales?: Maybe<Scalars['Float']['output']>;
  /** Maximum possible sales at full capacity */
  totalSalesLimit?: Maybe<Scalars['Float']['output']>;
  /** Total number of tickets available across the events */
  totalTickets?: Maybe<Scalars['Int']['output']>;
  /** Number of tickets still available for sale */
  totalTicketsAvailable?: Maybe<Scalars['Int']['output']>;
  /** Number of tickets currently on hold */
  totalTicketsOnHold?: Maybe<Scalars['Int']['output']>;
  /** Total ticket sales amount */
  totalTicketsSales?: Maybe<Scalars['Float']['output']>;
  /** Total ticket sales amount for today */
  totalTicketsSalesToday?: Maybe<Scalars['Float']['output']>;
  /** Total number of tickets sold */
  totalTicketsSold?: Maybe<Scalars['Int']['output']>;
  /** Number of tickets sold today */
  totalTicketsSoldToday?: Maybe<Scalars['Int']['output']>;
};

/** Artist data with detailed metadata and associations */
export type Artist = {
  __typename?: 'Artist';
  /** Attachments related to the artist */
  attachments?: Maybe<Array<ArtistAttachment>>;
  /** Biography or description of the artist */
  bio?: Maybe<Scalars['String']['output']>;
  /** Internal numeric ID of the artist */
  id: Scalars['Int']['output'];
  /** Timestamp of the last synchronization with external services */
  lastSynchronizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Links related to the artist */
  links?: Maybe<Array<ArtistLink>>;
  /** Display name of the artist */
  name: Scalars['String']['output'];
  /** Indicates if synchronization is available for this artist */
  synchronizationAvailable: Scalars['Boolean']['output'];
};

export type ArtistAttachment = {
  __typename?: 'ArtistAttachment';
  attachment: Attachment;
  attachmentId: Scalars['Int']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  /** ID of the account that owns the attachment */
  accountId: Scalars['Int']['output'];
  /** Checksum of the attachment file for integrity verification */
  checksum: Scalars['String']['output'];
  /** ID of the original attachment if this is a derived file */
  derivedFromId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the attachment */
  id: Scalars['Int']['output'];
  /** MIME type of the attachment file, e.g., image/jpeg, application/pdf */
  mime: Scalars['String']['output'];
  /** Name of the attachment file */
  name: Scalars['String']['output'];
  /** Size of the attachment file in bytes */
  size: Scalars['Int']['output'];
  status?: Maybe<AttachmentStatusEnum>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum AttachmentStatusEnum {
  Pending = 'PENDING',
  Ready = 'READY',
  Uploading = 'UPLOADING'
}

export type ArtistLink = {
  __typename?: 'ArtistLink';
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SearchResultArtist = {
  __typename?: 'SearchResultArtist';
  countryCode?: Maybe<Scalars['String']['output']>;
  genres?: Maybe<Array<ArtistGenre>>;
  id?: Maybe<Scalars['Int']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  soundchartsUuid?: Maybe<Scalars['String']['output']>;
};

export type ArtistGenre = {
  __typename?: 'ArtistGenre';
  root?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Array<Scalars['String']['output']>>;
};

/** The durable record of an event cancellation and its refund run, polled for the outcome */
export type CanceledEvent = {
  __typename?: 'CanceledEvent';
  /** When the cancellation was recorded */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the canceled event */
  eventId: Scalars['Int']['output'];
  /** Orders whose refund failed */
  failedRefunds: Array<FailedRefund>;
  /** Unique identifier for the cancellation */
  id: Scalars['Int']['output'];
  /** Derived status of the refund run */
  status: CanceledEventStatus;
  /** When the cancellation last changed */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An order whose refund failed during an event cancellation */
export type FailedRefund = {
  __typename?: 'FailedRefund';
  /** Why the refund failed */
  messages: Array<Scalars['String']['output']>;
  /** ID of the order that was not refunded */
  orderId: Scalars['ID']['output'];
};

/** Status of a cancellation refund run, with a pending run past its budget read as failed */
export enum CanceledEventStatus {
  /** The run failed or recorded no completion within its budget */
  Failed = 'FAILED',
  /** Refunds are still running */
  Pending = 'PENDING',
  /** The refund run completed; failed orders are listed on the cancellation */
  Ready = 'READY'
}

/** The currently authenticated user and their capabilities */
export type Me = {
  __typename?: 'Me';
  /** The current caller's account configuration */
  accountConfig?: Maybe<AccountConfig>;
  /** List of API keys associated with the user */
  apiKeys?: Maybe<Array<ApiKey>>;
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Unique identifier for the user */
  id: Scalars['Int']['output'];
  /** Name of the user */
  name?: Maybe<Scalars['String']['output']>;
  /** Current-user permission and allowance levels (keyed capability list) */
  permissions?: Maybe<Array<UserPermission>>;
  /** Passkeys registered by the user */
  webauthnCredentials: Array<WebauthnCredential>;
};

/** The current caller's account configuration (name, enabled features, prism access, default ticket layout) */
export type AccountConfig = {
  __typename?: 'AccountConfig';
  /** The account's default ticket layout, resolved: the account's own layout when set, otherwise the platform default. Null only when no ticket layout exists at all. */
  defaultTicketLayout?: Maybe<TicketLayout>;
  /** Enabled features for the account (includes prism_integration when prism access is granted) */
  features: Array<AccountFeature>;
  /** Account name */
  name: Scalars['String']['output'];
  /** Whether the caller has Prism FM access */
  prismAccess: Scalars['Boolean']['output'];
};

/** The account's ticket layout (id and name only) */
export type TicketLayout = {
  __typename?: 'TicketLayout';
  /** Ticket layout identifier */
  id: Scalars['Int']['output'];
  /** Human-readable layout name */
  name: Scalars['String']['output'];
};

export type AccountFeature = {
  __typename?: 'AccountFeature';
  accountId?: Maybe<Scalars['Int']['output']>;
  feature: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** API Key for a user */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** The account the key is pinned to */
  account?: Maybe<AccountSummary>;
  /** Creation timestamp of the API key */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Expiration timestamp of the API key, if applicable */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the API key */
  id: Scalars['Int']['output'];
  /** The API key value (masked) */
  key: Scalars['String']['output'];
  /** The name of the key */
  name?: Maybe<Scalars['String']['output']>;
  /** The key's permission groups and allowances; null if the key has none */
  permissionSet?: Maybe<PermissionSet>;
  /** How many webhook subscriptions, in any status, use this key; revoking it suspends them. Null unless the viewer can read webhooks on the key's account */
  webhookSubscriptionCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountSummary = {
  __typename?: 'AccountSummary';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A permission set as permission groups and allowances (read-only) */
export type PermissionSet = {
  __typename?: 'PermissionSet';
  allowances: Array<Allowance>;
  permissionGroups: Array<PermissionGroup>;
};

export type Allowance = {
  __typename?: 'Allowance';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type PermissionGroup = {
  __typename?: 'PermissionGroup';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export type Permission = {
  __typename?: 'Permission';
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  options: Array<PermissionOption>;
};

export type PermissionOption = {
  __typename?: 'PermissionOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserPermission = {
  __typename?: 'UserPermission';
  /** The key representing a specific permission. */
  key: PermissionKeyEnum;
  /** The level of access granted for the permission key. */
  level: PermissionLevelEnum;
};

export enum PermissionKeyEnum {
  AdminTools = 'ADMIN__TOOLS',
  AllowancesAddArtist = 'ALLOWANCES__ADD_ARTIST',
  AllowancesAddHold = 'ALLOWANCES__ADD_HOLD',
  AllowancesBoxOfficeApp = 'ALLOWANCES__BOX_OFFICE_APP',
  AllowancesCancelEvent = 'ALLOWANCES__CANCEL_EVENT',
  AllowancesConfirmDate = 'ALLOWANCES__CONFIRM_DATE',
  AllowancesDownloadWillCall = 'ALLOWANCES__DOWNLOAD_WILL_CALL',
  AllowancesPrismFm = 'ALLOWANCES__PRISM_FM',
  ArtistsFinancials = 'ARTISTS__FINANCIALS',
  ArtistsHospitalityRider = 'ARTISTS__HOSPITALITY_RIDER',
  ArtistsStatsSheet = 'ARTISTS__STATS_SHEET',
  ArtistsTechRider = 'ARTISTS__TECH_RIDER',
  BudgetActualConcessions = 'BUDGET__ACTUAL_CONCESSIONS',
  BudgetActualExpenses = 'BUDGET__ACTUAL_EXPENSES',
  BudgetActualIncomes = 'BUDGET__ACTUAL_INCOMES',
  BudgetProjectedConcessions = 'BUDGET__PROJECTED_CONCESSIONS',
  BudgetProjectedExpenses = 'BUDGET__PROJECTED_EXPENSES',
  BudgetProjectedIncomes = 'BUDGET__PROJECTED_INCOMES',
  BudgetSharedExpenses = 'BUDGET__SHARED_EXPENSES',
  BudgetSummary = 'BUDGET__SUMMARY',
  BudgetTemplate = 'BUDGET__TEMPLATE',
  CloseoutSheetAccess = 'CLOSEOUT_SHEET__ACCESS',
  CloseoutSheetManualTickets = 'CLOSEOUT_SHEET__MANUAL_TICKETS',
  CustomersCredits = 'CUSTOMERS__CREDITS',
  EventDetailsAnnounce = 'EVENT_DETAILS__ANNOUNCE',
  EventDetailsAuditLog = 'EVENT_DETAILS__AUDIT_LOG',
  EventDetailsCanceledDates = 'EVENT_DETAILS__CANCELED_DATES',
  EventDetailsConfirmedDates = 'EVENT_DETAILS__CONFIRMED_DATES',
  EventDetailsDeletedDates = 'EVENT_DETAILS__DELETED_DATES',
  EventDetailsHoldDates = 'EVENT_DETAILS__HOLD_DATES',
  EventDetailsName = 'EVENT_DETAILS__NAME',
  EventDetailsNotes = 'EVENT_DETAILS__NOTES',
  OtherArtists = 'OTHER__ARTISTS',
  OtherEventNotes = 'OTHER__EVENT_NOTES',
  OtherMemos = 'OTHER__MEMOS',
  OtherOrders = 'OTHER__ORDERS',
  OtherProjections = 'OTHER__PROJECTIONS',
  ReportsByDay = 'REPORTS__BY_DAY',
  ReportsByEmailOptIns = 'REPORTS__BY_EMAIL_OPT_INS',
  ReportsByEventCancelation = 'REPORTS__BY_EVENT_CANCELATION',
  ReportsByPayment = 'REPORTS__BY_PAYMENT',
  SalesInfoFees = 'SALES_INFO__FEES',
  SalesInfoGbor = 'SALES_INFO__GBOR',
  SalesInfoNumberSold = 'SALES_INFO__NUMBER_SOLD',
  SettingsIntegrations = 'SETTINGS__INTEGRATIONS',
  SettingsPrivileges = 'SETTINGS__PRIVILEGES',
  SettingsTeam = 'SETTINGS__TEAM',
  SettingsVenues = 'SETTINGS__VENUES',
  SettingsWebhooks = 'SETTINGS__WEBHOOKS',
  TicketingGuestList = 'TICKETING__GUEST_LIST',
  TicketingTickets = 'TICKETING__TICKETS',
  TicketingWillCall = 'TICKETING__WILL_CALL'
}

export enum PermissionLevelEnum {
  Edit = 'EDIT',
  None = 'NONE',
  Read = 'READ'
}

/** A passkey credential registered by a user */
export type WebauthnCredential = {
  __typename?: 'WebauthnCredential';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Array<Scalars['String']['output']>;
};

/** Represents a customer with derived account-scoped details */
export type CustomerDetails = {
  __typename?: 'CustomerDetails';
  /** Timestamp when the customer was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Credit balances and transactions grouped by currency */
  credits: Array<CustomerCreditsCache>;
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the customer agreed to email marketing from this account, as recorded at their most recent checkout on the account. NOT_ASKED covers customers who never went through checkout on it (box office, imported or manual orders) */
  emailOptIn: OptInStatus;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the customer */
  id: Scalars['Int']['output'];
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** List of orders this customer has placed in the account */
  orders: OrderConnection;
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the customer agreed to SMS marketing from this account, as recorded at their most recent checkout on the account. NOT_ASKED covers customers who never went through checkout on it (box office, imported or manual orders) */
  smsOptIn: OptInStatus;
};


/** Represents a customer with derived account-scoped details */
export type CustomerDetailsOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Credit balance and transactions for a customer in a single currency */
export type CustomerCreditsCache = {
  __typename?: 'CustomerCreditsCache';
  /** Current balance in this currency */
  balance: Scalars['Float']['output'];
  /** ISO currency code */
  currency: Scalars['String']['output'];
  /** Individual credit transactions in this currency */
  transactions: Array<CustomerCredit>;
};

/** A customer credit on an account */
export type CustomerCredit = {
  __typename?: 'CustomerCredit';
  /** Account the credit belongs to */
  accountId: Scalars['Int']['output'];
  /** Credit amount in the credit currency */
  amount: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the credit (null for legacy refund rows) */
  createdBy?: Maybe<PublicUser>;
  /** ISO currency code */
  currency: Scalars['String']['output'];
  /** Customer the credit belongs to */
  customer: Customer;
  /** Free-form description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier */
  id: Scalars['Int']['output'];
  /** Originating order, if the credit came from a refund */
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Public information about a user */
export type PublicUser = {
  __typename?: 'PublicUser';
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Name of the user */
  name: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  /** Timestamp when the customer was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the customer agreed to email marketing from this account, as recorded at their most recent checkout on the account. NOT_ASKED covers customers who never went through checkout on it (box office, imported or manual orders) */
  emailOptIn: OptInStatus;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the customer */
  id: Scalars['Int']['output'];
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the customer agreed to SMS marketing from this account, as recorded at their most recent checkout on the account. NOT_ASKED covers customers who never went through checkout on it (box office, imported or manual orders) */
  smsOptIn: OptInStatus;
};

/** A customer's marketing consent for one channel on an account */
export enum OptInStatus {
  /** The customer did not agree at their most recent checkout on the account */
  Declined = 'DECLINED',
  /** No checkout on the account recorded a choice; box office, imported and manual orders do not */
  NotAsked = 'NOT_ASKED',
  /** The customer agreed at their most recent checkout on the account */
  OptedIn = 'OPTED_IN'
}

/** The connection type for Order. */
export type OrderConnection = {
  __typename?: 'OrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Order>;
};

/** Represents an order in the system, basic details */
export type Order = {
  __typename?: 'Order';
  /** The account associated with the order */
  account: AccountSummary;
  /** Card brand used for the order (from cc_type); null for non-card payments */
  cardBrand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code of the order */
  currency: Scalars['String']['output'];
  /** The customer associated with the order */
  customer?: Maybe<Customer>;
  /** The order's own contact email; not the global customer record */
  email?: Maybe<Scalars['String']['output']>;
  /** The event associated with the order */
  event?: Maybe<Event>;
  /** Unique fingerprint of the order */
  fingerprint: Scalars['String']['output'];
  /** The order's own contact first name; not the global customer record */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the order */
  id: Scalars['Int']['output'];
  /** Last four digits of the credit card used for the order */
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  /** The order's own contact last name; not the global customer record */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The source of the order */
  origin: OrderOriginEnum;
  /** Payment method used for the order */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The order's own contact phone number; not the global customer record */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Computed refund status of the order (none/partial/full) */
  refundStatus: RefundStatusEnum;
  /** Number of tickets scanned */
  scannedCount: Scalars['Int']['output'];
  /** Staff user who made this box-office sale; null for online/imported orders */
  soldBy?: Maybe<PublicUser>;
  /** Current state of the order */
  state: Scalars['String']['output'];
  /** Total number of tickets purchased */
  ticketCount: Scalars['Int']['output'];
  /** Total amount of the order */
  total: Scalars['Float']['output'];
  /** Transaction ID associated with the order payment */
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Event data with detailed metadata and associations */
export type Event = {
  __typename?: 'Event';
  /** Announce detail metadata for the event */
  announceDetail?: Maybe<AnnounceDetail>;
  /** Who changed what on this event, newest first */
  auditLog: AuditLogEntryConnection;
  /** Are donations accepted for this event */
  availableForDonation?: Maybe<Scalars['Boolean']['output']>;
  /** Is processing fee applied to ticket purchases */
  availableForProcessingFee?: Maybe<Scalars['Boolean']['output']>;
  /** Is sales tax applied to ticket purchases */
  availableForSalesTax?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the caller can add a ticket section to this event; false on a seating-chart event or without the ticketing edit permission */
  canAddSections: Scalars['Boolean']['output'];
  /** The latest cancellation report CSV export, re-read for a fresh downloadUrl */
  cancellationExport?: Maybe<EventExport>;
  /** Additional email content */
  confirmationEmailContent?: Maybe<Scalars['String']['output']>;
  /** Whether this event is linked to a Prism.fm event */
  connectedToPrism: Scalars['Boolean']['output'];
  /** Calendar date of the event */
  date: Scalars['ISO8601Date']['output'];
  /** Full event description or program */
  description?: Maybe<Scalars['String']['output']>;
  /** Text shown on the donation button at checkout */
  donationButtonText?: Maybe<Scalars['String']['output']>;
  /** Description of what the donation supports */
  donationDescription?: Maybe<Scalars['String']['output']>;
  /** Time when the venue doors open, in ISO8601 format */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when the event is expected to end, in ISO8601 format */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event group the event belongs to */
  eventGroup?: Maybe<EventGroup>;
  /** Additional content shown in the event's footer */
  footerContent?: Maybe<Scalars['String']['output']>;
  /** Full event slug name and key */
  fullSlug?: Maybe<Scalars['String']['output']>;
  /** Guest lists for the event, by name, case-folded */
  guestLists: Array<GuestList>;
  /** Hold priority of the event */
  holdPreference?: Maybe<Scalars['Int']['output']>;
  /** Internal numeric ID of the event */
  id: Scalars['Int']['output'];
  /** Are PDF tickets mailed to attendees */
  mailPdfTickets?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum age required to attend the event */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** Display name of the event */
  name: Scalars['String']['output'];
  /** Rich-text content shown on the order confirmation page */
  orderConfirmationContent?: Maybe<Scalars['String']['output']>;
  /** Presales for this event */
  presales: Array<Presale>;
  /** Prism.fm event ID linked to this event */
  prismEventId?: Maybe<Scalars['Int']['output']>;
  /** Token used to construct the shareable report URL */
  reportShareToken?: Maybe<Scalars['String']['output']>;
  /** The latest daily sales CSV export, re-read for a fresh downloadUrl */
  salesExport?: Maybe<EventExport>;
  /** Seating chart associated with the event */
  seatingChart?: Maybe<SeatingChart>;
  /** Ticket sections by name, unnamed last; null with an authorization error without the ticketing view permission */
  sections?: Maybe<Array<TicketSection>>;
  /** Whether will-call reminder emails are sent for this event */
  sendWillCallReminders?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the event, used in URLs */
  slug: Scalars['String']['output'];
  /** Time when the event is scheduled to start, in ISO8601 format */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lifecycle state of the event */
  state: EventStateEnum;
  /** Whether the event has any tickets defined */
  ticketed?: Maybe<Scalars['Boolean']['output']>;
  /** Tickets held back from sale, in display order */
  ticketHolds: Array<TicketHold>;
  /** Maximum number of tickets that can be purchased in a single order */
  ticketLimit?: Maybe<Scalars['Int']['output']>;
  ticketSales?: Maybe<Array<TicketSales>>;
  /** URL where tickets for the event can be purchased */
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  /** Event-level ticket sales totals */
  ticketTotals?: Maybe<EventSales>;
  /** Timezone of the event/venue location */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Venue where the event takes place */
  venue?: Maybe<Venue>;
  /** Room within the venue where the event takes place */
  venueRoom?: Maybe<VenueRoom>;
  /** The latest will-call CSV export, re-read for a fresh downloadUrl */
  willCallExport?: Maybe<EventExport>;
  /** People collecting tickets at will call, by last then first name */
  willCallList: Array<WillCallEntry>;
};


/** Event data with detailed metadata and associations */
export type EventAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The announce detail for an event */
export type AnnounceDetail = {
  __typename?: 'AnnounceDetail';
  /** Associated announce artists */
  announceArtists?: Maybe<Array<AnnounceArtist>>;
  /** When the event is announced */
  announceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Linked attachments */
  attachments?: Maybe<Array<AnnounceAttachment>>;
  /** Custom call-to-action button text */
  buttonText?: Maybe<Scalars['String']['output']>;
  /** Categorisation category */
  category?: Maybe<Category>;
  /** When the announce detail was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Default VenuePilot tickets URL for the event */
  defaultTicketsUrl?: Maybe<Scalars['String']['output']>;
  /** Default VenuePilot tickets URL opened in a new tab */
  defaultTicketsUrlNewTab?: Maybe<Scalars['String']['output']>;
  /** Announce description */
  description?: Maybe<Scalars['String']['output']>;
  /** Artists booked on the event */
  eventArtists?: Maybe<Array<EventArtist>>;
  /** ID of the announced event */
  eventId?: Maybe<Scalars['Int']['output']>;
  /** Public name of the event */
  eventName?: Maybe<Scalars['String']['output']>;
  /** Facebook URL */
  facebookUrl?: Maybe<Scalars['String']['output']>;
  /** Handstamp URL for the event, if configured */
  handstampUrl?: Maybe<Scalars['String']['output']>;
  /** Index of the highlighted image */
  highlightedImageIdx?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the announce detail */
  id?: Maybe<Scalars['Int']['output']>;
  /** Image URLs */
  images?: Maybe<Array<Scalars['String']['output']>>;
  /** Instagram URL */
  instagramUrl?: Maybe<Scalars['String']['output']>;
  /** When tickets go on sale */
  onSaleAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Promoter name */
  promoter?: Maybe<Scalars['String']['output']>;
  /** Categorisation subcategory */
  subcategory?: Maybe<Subcategory>;
  /** Support act details */
  support?: Maybe<Scalars['String']['output']>;
  /** Tags for the announce */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Tickets URL shown for the event */
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  /** Source of the tickets URL */
  ticketsUrlType?: Maybe<TicketsUrlTypeEnum>;
  /** Conversion tracking providers */
  tracking?: Maybe<Array<TrackingEntry>>;
  /** When the announce was triggered */
  triggeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Twitter URL */
  twitterUrl?: Maybe<Scalars['String']['output']>;
  /** Categorisation type */
  type?: Maybe<Type>;
  /** When the announce detail was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** An artist associated with an announce detail */
export type AnnounceArtist = {
  __typename?: 'AnnounceArtist';
  /** ID of the account that owns the artist */
  accountId: Scalars['Int']['output'];
  /** Apple Music URL */
  applemusic?: Maybe<Scalars['String']['output']>;
  /** Bandcamp URL */
  bandcamp?: Maybe<Scalars['String']['output']>;
  /** When the artist was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Facebook URL */
  facebook?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the announce artist */
  id: Scalars['Int']['output'];
  /** Instagram URL */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Last.fm URL */
  lastfm?: Maybe<Scalars['String']['output']>;
  /** Name of the artist */
  name: Scalars['String']['output'];
  /** Songkick URL */
  songkick?: Maybe<Scalars['String']['output']>;
  /** Spotify URL */
  spotify?: Maybe<Scalars['String']['output']>;
  /** Twitter URL */
  twitter?: Maybe<Scalars['String']['output']>;
  /** When the artist was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Website URL */
  website?: Maybe<Scalars['String']['output']>;
  /** Wikipedia URL */
  wikipedia?: Maybe<Scalars['String']['output']>;
  /** YouTube URL */
  youtube?: Maybe<Scalars['String']['output']>;
};

/** An attachment linked to an announce detail */
export type AnnounceAttachment = {
  __typename?: 'AnnounceAttachment';
  /** The linked attachment */
  attachment: Attachment;
  /** ID of the linked attachment */
  attachmentId: Scalars['Int']['output'];
  /** Whether the attachment is highlighted */
  highlighted?: Maybe<Scalars['Boolean']['output']>;
};

/** Category */
export type Category = {
  __typename?: 'Category';
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** Name of the category */
  name: Scalars['String']['output'];
  /** Subcategories belonging to this category */
  subcategories: Array<Subcategory>;
};

/** Subcategory */
export type Subcategory = {
  __typename?: 'Subcategory';
  /** Category identifier this subcategory belongs to */
  categoryId: Scalars['String']['output'];
  /** Unique identifier for the subcategory */
  id: Scalars['String']['output'];
  /** Name of the subcategory */
  name: Scalars['String']['output'];
};

/** Event Artist data with detailed metadata and associations */
export type EventArtist = {
  __typename?: 'EventArtist';
  /** The artist associated with this artist */
  artist: Artist;
  /** Dressing-room curfew time for this date */
  dressingRoomCurfew?: Maybe<Scalars['Time']['output']>;
  /** The event associated with this artist */
  event: EventSummary;
  /** Whether this artist headlines this date (co-headliners allowed) */
  headliner: Scalars['Boolean']['output'];
  /** Internal numeric ID of the event artist */
  id: Scalars['Int']['output'];
  /** Legacy event artist, used for compatibility with settlement sheets */
  legacyEventArtistId?: Maybe<Scalars['Int']['output']>;
  /**
   * Legacy offer sheet ID for compatibility with settlement sheets
   * @deprecated Use offerSheetId
   */
  legacyOfferSheetId?: Maybe<Scalars['Int']['output']>;
  /**
   * Legacy settlement sheet ID
   * @deprecated Use eventArtistSettlements(eventGroupId:, artistId:)
   */
  legacySettlementSheetId?: Maybe<Scalars['Int']['output']>;
  /** ID of the artist's current offer sheet for this date's event group */
  offerSheetId?: Maybe<Scalars['Int']['output']>;
  /** Off-stage (set end) time for this event artist */
  offStage?: Maybe<Scalars['Time']['output']>;
  /** On-stage (set start) time for this event artist */
  onStage?: Maybe<Scalars['Time']['output']>;
  /** Riders (hospitality/tech) for this event artist */
  riders?: Maybe<Array<EventArtistRider>>;
};

/** The event data with basic metadata and associations */
export type EventSummary = {
  __typename?: 'EventSummary';
  /** Announce detail metadata for the event */
  announceDetail?: Maybe<AnnounceDetail>;
  /** Calendar date of the event */
  date: Scalars['ISO8601Date']['output'];
  /** Full event description or program */
  description?: Maybe<Scalars['String']['output']>;
  /** Time when the venue doors open, in ISO8601 format */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when the event is expected to end, in ISO8601 format */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event group the event belongs to */
  eventGroup?: Maybe<EventGroup>;
  /** Additional content shown in the event's footer */
  footerContent?: Maybe<Scalars['String']['output']>;
  /** Hold priority of the event */
  holdPreference?: Maybe<Scalars['Int']['output']>;
  /** Internal numeric ID of the event */
  id: Scalars['Int']['output'];
  /** Minimum age required to attend the event */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** Display name of the event */
  name: Scalars['String']['output'];
  /** Seating chart associated with the event */
  seatingChart?: Maybe<SeatingChart>;
  /** Unique identifier for the event, used in URLs */
  slug: Scalars['String']['output'];
  /** Time when the event is scheduled to start, in ISO8601 format */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lifecycle state of the event */
  state: EventStateEnum;
  /** Whether the event has any tickets defined */
  ticketed?: Maybe<Scalars['Boolean']['output']>;
  /** URL where tickets for the event can be purchased */
  ticketsUrl?: Maybe<Scalars['String']['output']>;
  /** Event-level ticket sales totals */
  ticketTotals?: Maybe<EventSales>;
  /** Timezone of the event/venue location */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Venue where the event takes place */
  venue?: Maybe<Venue>;
  /** Room within the venue where the event takes place */
  venueRoom?: Maybe<VenueRoom>;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  events: Array<Event>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Seating Chart data with detailed metadata and associations */
export type SeatingChart = {
  __typename?: 'SeatingChart';
  /** Whether the chart can be deleted */
  deletable: Scalars['Boolean']['output'];
  /** URL of the draft thumbnail image for the seating chart */
  draftThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the chart has an unpublished draft */
  hasDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the seating chart */
  id: Scalars['Int']['output'];
  /** Unique key for the seating chart */
  key: Scalars['String']['output'];
  /** Chart name for the seating chart */
  name: Scalars['String']['output'];
  /** Parent seating chart ID if this is a derived chart */
  parentId?: Maybe<Scalars['Int']['output']>;
  /** URL of the published thumbnail image for the seating chart */
  publishedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Publication status of the chart */
  status?: Maybe<Scalars['String']['output']>;
  /** Whether the chart can be assigned to an event */
  usable: Scalars['Boolean']['output'];
};

export type Venue = {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Default values associated with this venue, used to seed event build forms */
  defaultSet?: Maybe<DefaultSet>;
  id?: Maybe<Scalars['Int']['output']>;
  includeCcFee?: Maybe<Scalars['Boolean']['output']>;
  includeConvenienceFee?: Maybe<Scalars['Boolean']['output']>;
  includeTaxFee?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Attachment>;
  logoId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  processingFeePercentage?: Maybe<Scalars['Float']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Array<VenueRoom>>;
  salesTax?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Physical address with components such as street, city, state, postal code, and country. */
export type Address = {
  __typename?: 'Address';
  /** City of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the address, using ISO 3166-1 alpha-2 codes */
  country?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the address */
  id: Scalars['Int']['output'];
  /** Postal or ZIP code of the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** State or province of the address */
  state?: Maybe<Scalars['String']['output']>;
  /** Primary street address */
  street1?: Maybe<Scalars['String']['output']>;
  /** Secondary street address or apartment/suite number */
  street2?: Maybe<Scalars['String']['output']>;
};

/** Default values set for a given defaultable object */
export type DefaultSet = {
  __typename?: 'DefaultSet';
  /** Default values */
  defaults: Scalars['JSON']['output'];
  /** Unique identifier for the default set */
  id: Scalars['Int']['output'];
};

/** Represents a room within a venue */
export type VenueRoom = {
  __typename?: 'VenueRoom';
  /** Unique identifier for the venue room */
  id: Scalars['Int']['output'];
  /** Name of the venue room */
  name: Scalars['String']['output'];
  /** Venue this room belongs to */
  venue: Venue;
};

/** A hospitality or tech rider attached to an event artist */
export type EventArtistRider = {
  __typename?: 'EventArtistRider';
  /** Artist load-in time */
  artistLoadInTime?: Maybe<Scalars['String']['output']>;
  /** Attachments for the rider */
  attachments?: Maybe<Array<Attachment>>;
  /** Number of backstage passes */
  backstagePassesNumber?: Maybe<Scalars['Int']['output']>;
  /** Internal numeric ID of the rider */
  id: Scalars['Int']['output'];
  /** Free-form notes for the rider */
  notes?: Maybe<Scalars['String']['output']>;
  /** Type of the rider (hospitality or tech) */
  riderType: EventArtistRiderTypeEnum;
  /** Sound check type: "Full" or "Line" */
  soundCheckType?: Maybe<Scalars['String']['output']>;
  /** Number of performers on stage */
  stagePerformersNumber?: Maybe<Scalars['Int']['output']>;
  /** Stage sound check time */
  stageSoundCheckTime?: Maybe<Scalars['String']['output']>;
};

/** Type of event-artist rider */
export enum EventArtistRiderTypeEnum {
  Hospitality = 'HOSPITALITY',
  Tech = 'TECH'
}

/** Source of the tickets URL shown for an announced event */
export enum TicketsUrlTypeEnum {
  Custom = 'CUSTOM',
  Handstamp = 'HANDSTAMP',
  NoUrl = 'NO_URL',
  VenuepilotCheckout = 'VENUEPILOT_CHECKOUT'
}

/** A configured conversion tracking provider on an announce detail */
export type TrackingEntry = {
  __typename?: 'TrackingEntry';
  /** Optional conversion label for the tracking provider */
  conversionLabel?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the tracking provider entry */
  id?: Maybe<Scalars['Int']['output']>;
  /** The tracking provider */
  provider: TrackingProviderEnum;
  /** The provider-specific tracking identifier */
  trackingId: Scalars['String']['output'];
};

/** Third-party conversion tracking provider */
export enum TrackingProviderEnum {
  /** Facebook Pixel */
  Facebook = 'facebook',
  /** Google Analytics */
  Ga = 'ga',
  /** Reddit Pixel */
  Reddit = 'reddit',
  /** TikTok Pixel */
  TikTok = 'tik_tok'
}

/** Type */
export type Type = {
  __typename?: 'Type';
  /** Unique identifier for the type */
  id: Scalars['String']['output'];
  /** Name of the type */
  name: Scalars['String']['output'];
};

/** The connection type for AuditLogEntry. */
export type AuditLogEntryConnection = {
  __typename?: 'AuditLogEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditLogEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AuditLogEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogEntryEdge = {
  __typename?: 'AuditLogEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuditLogEntry>;
};

/** One recorded change: who did what to which object, and when */
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  /** Who made the change */
  actor?: Maybe<AuditLogActor>;
  /** Which change an edit was, when the verb alone does not say; null otherwise */
  change?: Maybe<AuditLogChange>;
  /** When the change was made */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Id of the entry */
  id: Scalars['Int']['output'];
  /** What was changed */
  object: AuditLogObject;
  /** Fields the change touched */
  updates: Array<AuditLogUpdate>;
  /** What was done */
  verb: AuditLogVerb;
};

/** The user who made an audited change */
export type AuditLogActor = {
  __typename?: 'AuditLogActor';
  /** Id of the user */
  id: Scalars['Int']['output'];
  /** Name of the user, kept after they are removed */
  name?: Maybe<Scalars['String']['output']>;
};

/** Which change an edit was, where the verb alone does not say */
export enum AuditLogChange {
  /** Delivery was switched on or off; updates carry the resulting status */
  DeliverySwitched = 'delivery_switched',
  /** A member took ownership, becoming its principal; a suspended subscription resumed */
  OwnershipTaken = 'ownership_taken',
  /** The signing secret was rotated */
  SecretRotated = 'secret_rotated',
  /** Staff made the scanned tickets of a ticket type scannable again; updates carry the count */
  TicketsUnscanned = 'tickets_unscanned'
}

/** What an audit-log entry changed */
export enum AuditLogObject {
  /** Account settings */
  Account = 'account',
  /** An account feature flag */
  AccountFeature = 'account_feature',
  /** Announcement details */
  AnnounceInfo = 'announce_info',
  /** An artist on the bill */
  Artist = 'artist',
  /** The event while still a tentative booking hold; stored as `hold`. Rows recorded before the held type was stored are inferred and can mislabel a ticket hold */
  BookingHold = 'booking_hold',
  /** A confirmed date */
  ConfirmedEvent = 'confirmed_event',
  /** A customer credit */
  CustomerCredit = 'customer_credit',
  /** A discount code */
  Discount = 'discount',
  /** The event itself */
  Event = 'event',
  /** A loan */
  Loan = 'loan',
  /** The platform-wide Looker report registry setting */
  LookerReports = 'looker_reports',
  /** Event notes */
  Notes = 'notes',
  /** A sold ticket on an order */
  OrderTicket = 'order_ticket',
  /** A presale */
  Presale = 'presale',
  /** Financial projections */
  Projection = 'projection',
  /** A ticket section; stored as `bucket` */
  Section = 'section',
  /** A ticket type (TicketBlueprint) */
  Ticket = 'ticket',
  /** Tickets held back from sale; stored as `hold` */
  TicketHold = 'ticket_hold',
  /** Ticketing details of a confirmed event */
  TicketingEvent = 'ticketing_event',
  /** A Turnstile widget; its secret is never recorded */
  TurnstileWidget = 'turnstile_widget',
  /** An outbound webhook subscription */
  WebhookSubscription = 'webhook_subscription',
  /** A whitelabel configuration */
  WhitelabelConfig = 'whitelabel_config'
}

/** One field an audited change touched, with its value before and after */
export type AuditLogUpdate = {
  __typename?: 'AuditLogUpdate';
  /** Stored column name; ticket sections read `section_id` */
  field: Scalars['String']['output'];
  /** Value before the change; credentials are masked */
  from?: Maybe<Scalars['JSON']['output']>;
  /** Value after the change; credentials are masked */
  to?: Maybe<Scalars['JSON']['output']>;
};

/** What was done to the object of an audit-log entry */
export enum AuditLogVerb {
  /** Created */
  Add = 'add',
  /** Canceled */
  Cancel = 'cancel',
  /** Duplicated */
  Duplicate = 'duplicate',
  /** Changed */
  Edit = 'edit',
  /** Deleted */
  Remove = 'remove'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A generated export artifact for an event or list, downloaded through a short-lived link */
export type EventExport = {
  __typename?: 'EventExport';
  /** When the export was first requested */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Presigned link minted per request; null unless the export is ready */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Number of rows that failed, where the kind records it */
  errorCount?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the export */
  id: Scalars['Int']['output'];
  /** Which artifact this export holds */
  kind: EventExportKind;
  /** Number of rows in the artifact, where the kind records it */
  rowCount?: Maybe<Scalars['Int']['output']>;
  /** Derived status of the export */
  status: EventExportStatus;
  /** When the export last changed */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Which generated artifact an export holds */
export enum EventExportKind {
  /** The cancellation export */
  Cancellation = 'CANCELLATION',
  /** The list import export */
  ListImport = 'LIST_IMPORT',
  /** The sales export */
  Sales = 'SALES',
  /** The will call export */
  WillCall = 'WILL_CALL'
}

/** Status of an export, with a pending export past its budget read as failed */
export enum EventExportStatus {
  /** Generation failed or recorded no completion within its budget */
  Failed = 'FAILED',
  /** Generation has not finished */
  Pending = 'PENDING',
  /** The file is stored and can be downloaded */
  Ready = 'READY'
}

/** An event's door list of named guests, each with a quantity claimed as they arrive */
export type GuestList = {
  __typename?: 'GuestList';
  /** Total admissions on the list: the sum of entry quantities */
  allotment: Scalars['Int']['output'];
  /** Admissions claimed across all entries */
  claimed: Scalars['Int']['output'];
  /** When the list was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Guests on the list, by last name */
  entries: Array<GuestListEntry>;
  /** ID of the event the list belongs to */
  eventId: Scalars['Int']['output'];
  /** Internal numeric ID of the list */
  id: Scalars['Int']['output'];
  /** The latest CSV import, polled until ready or failed */
  importExport?: Maybe<EventExport>;
  /** Name of the list, unique within the event; null on legacy lists */
  name?: Maybe<Scalars['String']['output']>;
  /** When the list was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A named guest on a guest list, admitted up to a quantity */
export type GuestListEntry = {
  __typename?: 'GuestListEntry';
  /** Admissions already claimed at the door; read-only here */
  claimed: Scalars['Int']['output'];
  /** First name of the guest */
  firstName: Scalars['String']['output'];
  /** ID of the guest list the entry is on */
  guestListId: Scalars['Int']['output'];
  /** Internal numeric ID of the entry */
  id: Scalars['Int']['output'];
  /** Last name of the guest */
  lastName: Scalars['String']['output'];
  /** Admissions the guest is allowed; never below the claimed count */
  quantity: Scalars['Int']['output'];
};

/** A presale for an event */
export type Presale = {
  __typename?: 'Presale';
  /** Whether the presale is currently active */
  active: Scalars['Boolean']['output'];
  /** When the presale was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Id of the event the presale belongs to */
  eventId: Scalars['Int']['output'];
  /** Id of the presale */
  id: Scalars['Int']['output'];
  /** URL-safe identifier derived from the name */
  link?: Maybe<Scalars['String']['output']>;
  /** Name of the presale */
  name: Scalars['String']['output'];
  /** Optional password required to access the presale */
  password?: Maybe<Scalars['String']['output']>;
  /** When the presale stops selling */
  sellEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the presale starts selling */
  sellStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether to show upcoming info for the presale */
  showUpcomingInfo?: Maybe<Scalars['Boolean']['output']>;
  /** Ids of the ticket blueprints sold in this presale */
  ticketBlueprintIds: Array<Scalars['Int']['output']>;
  /** When the presale was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Full shareable URL to the public presale page, resolved per event */
  url?: Maybe<Scalars['String']['output']>;
};

/** A shared allotment pool that section-backed tickets draw from */
export type TicketSection = {
  __typename?: 'TicketSection';
  /** Hex colour the section is shown in */
  color: Scalars['String']['output'];
  /** Whether the section can be deleted; false while tickets draw on it or on a seating-chart event */
  deletable: Scalars['Boolean']['output'];
  /** Whether the section's name and quantity can be edited; false on a seating-chart event */
  editable: Scalars['Boolean']['output'];
  /** Internal numeric ID of the section */
  id: Scalars['Int']['output'];
  /** Display name of the section; null when unnamed */
  name?: Maybe<Scalars['String']['output']>;
  /** Tickets the section can sell across all its tickets */
  quantity: Scalars['Int']['output'];
  /** Tickets the section can still sell: quantity minus sold, locked and held. A section-level figure, not a sum of its tickets */
  remaining: Scalars['Int']['output'];
  /** Tickets drawing on this section, in display order */
  tickets: Array<TicketBlueprint>;
};

/** A sellable ticket for an event. Holds are not tickets and never appear as this type */
export type TicketBlueprint = {
  __typename?: 'TicketBlueprint';
  /** Tickets this row may sell on its own; null when it sells to its section limit */
  allotment?: Maybe<Scalars['Int']['output']>;
  /** Whether the ticket can be sold during a presale */
  availableOnPresale: Scalars['Boolean']['output'];
  /** When the ticket was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Ticket whose sale closing puts this one on sale, instead of a sell window */
  dependencyId?: Maybe<Scalars['Int']['output']>;
  /** Description shown to buyers */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the event the ticket belongs to */
  eventId: Scalars['Int']['output'];
  /** Per-ticket fee added to the price */
  fee?: Maybe<Scalars['Float']['output']>;
  /** Internal numeric ID of the ticket */
  id: Scalars['Int']['output'];
  /** Whether the ticket is admission or an add-on */
  kind: TicketBlueprintKind;
  /** Most tickets a buyer can purchase in one order */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** Fewest tickets a buyer can purchase in one order */
  minimum?: Maybe<Scalars['Int']['output']>;
  /** Tickets must be purchased in multiples of this number */
  multiple?: Maybe<Scalars['Int']['output']>;
  /** Display name of the ticket */
  name: Scalars['String']['output'];
  /** Display position among the event tickets, ascending */
  orderPriority: Scalars['Int']['output'];
  /** Face value of the ticket */
  price?: Maybe<Scalars['Float']['output']>;
  /** Section this ticket draws its allotment from; null when self-allotted */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** Channels the ticket is sold through */
  sellableThrough: Array<TicketSellableThrough>;
  /** When this ticket stops selling */
  sellEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this ticket goes on sale */
  sellStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the ticket was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Whether a ticket is admission or an add-on */
export enum TicketBlueprintKind {
  Addon = 'addon',
  Ticket = 'ticket'
}

/** A channel a ticket can be sold through */
export enum TicketSellableThrough {
  BoxOffice = 'box_office',
  Online = 'online'
}

/** Tickets held back from sale out of a source ticket's allotment. Not a booking hold, which is a tentative event */
export type TicketHold = {
  __typename?: 'TicketHold';
  /** When the hold was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Internal note on what the hold is for */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the event the hold belongs to */
  eventId: Scalars['Int']['output'];
  /** Internal numeric ID of the hold */
  id: Scalars['Int']['output'];
  /** Display name of the hold */
  name: Scalars['String']['output'];
  /** Display position among the event holds, ascending */
  orderPriority: Scalars['Int']['output'];
  /** Tickets held back from sale */
  quantity: Scalars['Int']['output'];
  /** Ticket whose allotment this hold draws from */
  sourceTicketId: Scalars['Int']['output'];
  /** When the hold was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Ticket sales breakdown for an event */
export type TicketSales = {
  __typename?: 'TicketSales';
  /** ID of the ticket blueprint */
  blueprintId?: Maybe<Scalars['Int']['output']>;
  /** Name of the ticket blueprint */
  blueprintName?: Maybe<Scalars['String']['output']>;
  /** The discount code of the ticket discount */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** Total net fees associated with the ticket sales */
  netFees?: Maybe<Scalars['Float']['output']>;
  /** Total net sales amount for the tickets sold */
  netSales?: Maybe<Scalars['Float']['output']>;
  /** Total of net sales and fees for the tickets sold */
  netSalesAndFees?: Maybe<Scalars['Float']['output']>;
  /** Total number of tickets sold */
  numberSold?: Maybe<Scalars['Int']['output']>;
  /** Face value of the ticket */
  price?: Maybe<Scalars['Float']['output']>;
  /** Total amount refunded from ticket sales */
  salesRefunded?: Maybe<Scalars['Float']['output']>;
};

/** One ticket holder on one order collecting tickets at will call */
export type WillCallEntry = {
  __typename?: 'WillCallEntry';
  /** First name the tickets are held under */
  firstName: Scalars['String']['output'];
  /** Guest-list entry being collected; null for orders */
  guestListEntryId?: Maybe<Scalars['Int']['output']>;
  /** Last name the tickets are held under */
  lastName: Scalars['String']['output'];
  /** Order the tickets belong to; null for guest-list entries */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** Tickets being collected, by type */
  tickets: Array<WillCallTicketGroup>;
};

/** Tickets one person is collecting at will call of a single ticket type */
export type WillCallTicketGroup = {
  __typename?: 'WillCallTicketGroup';
  /** Ticket type name, or the guest list name for guest-list entries */
  name: Scalars['String']['output'];
  /** Number of tickets of this type being collected */
  quantity: Scalars['Int']['output'];
  /** Assigned seats; empty when the tickets are unseated */
  seats: Array<Scalars['String']['output']>;
  /** ID of the ticket type; null for guest-list entries */
  ticketBlueprintId?: Maybe<Scalars['Int']['output']>;
};

export enum OrderOriginEnum {
  Online = 'online',
  Register = 'register'
}

export enum RefundStatusEnum {
  Full = 'full',
  None = 'none',
  Partial = 'partial'
}

export type CustomerSearchArguments = {
  /** Filter customers created after this date/time */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter customers created before this date/time */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Only customers whose email opt-in status on the current account is one of these; omitted or empty leaves email unfiltered */
  emailOptIn?: InputMaybe<Array<OptInStatus>>;
  /** General search query matching first name, last name, or email */
  q?: InputMaybe<Scalars['String']['input']>;
  /** Only customers whose SMS opt-in status on the current account is one of these; omitted or empty leaves SMS unfiltered */
  smsOptIn?: InputMaybe<Array<OptInStatus>>;
};

export type OrderingArgument = {
  /** The direction of ordering, either 'asc' or 'desc'. */
  direction: Scalars['String']['input'];
  /** The field to order by. */
  field: Scalars['String']['input'];
};

/** The connection type for Customer. */
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CustomerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Customer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Customers matching the account scope and filters, ignoring pagination; each customer counted once. Lets a full pull be checked for completeness. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomerEdge = {
  __typename?: 'CustomerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Customer>;
};

/** A discount code for an event */
export type Discount = {
  __typename?: 'Discount';
  /** Discount amount, either a fixed amount ($) or a percentage (%) */
  amount: Scalars['String']['output'];
  /** Code customers enter to redeem the discount */
  code?: Maybe<Scalars['String']['output']>;
  /** When the discount was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Id of the event the discount belongs to */
  eventId: Scalars['Int']['output'];
  /** When the discount expires */
  expiration?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Id of the discount */
  id: Scalars['Int']['output'];
  /** Whether the discount is a fixed amount */
  isFixedAmount: Scalars['Boolean']['output'];
  /** Whether the discount is a percentage */
  isPercentage: Scalars['Boolean']['output'];
  /** Joinit membership type the discount is tied to */
  joinitMembershipType?: Maybe<Scalars['String']['output']>;
  /** Whether the discount is a percentage or fixed */
  kind: DiscountKindEnum;
  /** Human-readable label for the discount */
  label: Scalars['String']['output'];
  /** Maximum number of times the discount can be used */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Discount value as a plain number (use with kind) */
  numericAmount: Scalars['Float']['output'];
  /** Ids of the ticket blueprints the discount applies to */
  ticketBlueprintIds: Array<Scalars['Int']['output']>;
  /** Number of times the discount has been used */
  timesUsed: Scalars['Int']['output'];
  /** Type of the discount, either 'standard' or 'joinit' */
  type: Scalars['String']['output'];
  /** When the discount was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the discount can still be used */
  usable: Scalars['Boolean']['output'];
};

/** Whether a discount is a percentage or a fixed monetary amount */
export enum DiscountKindEnum {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

/** Email schedule for an event */
export type EmailSchedule = {
  __typename?: 'EmailSchedule';
  /** 'Bcc' field list of emails */
  bcc?: Maybe<Array<Scalars['String']['output']>>;
  /** 'Cc' field list of emails */
  cc?: Maybe<Array<Scalars['String']['output']>>;
  /** Days of the week the email is sent on */
  daysOfWeek: Array<DayOfWeekEnum>;
  /** Type of email to schedule */
  emailType: EmailScheduleEmailTypeEnum;
  /** Last date the schedule is active */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Id of the event */
  eventId: Scalars['Int']['output'];
  /** Hour of the day to send the email at, in the venue timezone */
  hour: Scalars['Int']['output'];
  /** Id of the email schedule */
  id: Scalars['Int']['output'];
  /** When the email was last sent at */
  lastSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Minute of the hour to send the email at, in the venue timezone */
  minute: Scalars['Int']['output'];
  /** First date the schedule is active */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 'To' field list of emails */
  to?: Maybe<Array<Scalars['String']['output']>>;
};

/** Day of the week mapped to its integer value (Sunday=0 … Saturday=6, matching Ruby Date#wday) */
export enum DayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum EmailScheduleEmailTypeEnum {
  ShareableReport = 'SHAREABLE_REPORT'
}

/** An artist settlement with its deals, payments, expenses and tax detail */
export type Settlement = {
  __typename?: 'Settlement';
  /** Payee address for the settlement */
  address?: Maybe<Address>;
  /** ID of the artist the settlement belongs to */
  artistId: Scalars['ID']['output'];
  /** Events the settlement can be based on */
  availableEvents?: Maybe<Array<SettlementEvent>>;
  /** Bar/rental deal lines */
  barDeals?: Maybe<Array<SettlementDeal>>;
  /** Business name on the settlement */
  businessName?: Maybe<Scalars['String']['output']>;
  /** When the settlement was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Custom expense lines */
  customExpenses?: Maybe<Array<SettlementCustomExpense>>;
  /** Deal lines */
  deals?: Maybe<Array<SettlementDeal>>;
  /** ID of the event group the settlement belongs to */
  eventGroupId: Scalars['ID']['output'];
  /** IDs of the events the settlement is based on */
  eventIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Events selected for the settlement */
  events?: Maybe<Array<SettlementEvent>>;
  /** Unique identifier for the settlement */
  id: Scalars['Int']['output'];
  /** Manual ticket sales */
  manualTicketSales?: Maybe<Array<SettlementManualTicketSale>>;
  /** Payments made on the settlement */
  payments?: Maybe<Array<SettlementPayment>>;
  /** URL of the generated settlement PDF, if any */
  pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** URL of the printable settlement sheet */
  printableUrl?: Maybe<Scalars['String']['output']>;
  /** How the settlement is calculated */
  settlementType?: Maybe<SettlementTypeEnum>;
  /** Signed contracts */
  signedContracts?: Maybe<Array<SettlementContract>>;
  /** Tax detail attachments */
  taxAttachments?: Maybe<Array<SettlementAttachment>>;
  /** Tax identifier on the settlement */
  taxId?: Maybe<Scalars['String']['output']>;
  /** Label for the tax withholding */
  taxLabel?: Maybe<Scalars['String']['output']>;
  /** Tax withholding amount */
  taxWithholdingAmount?: Maybe<Scalars['Float']['output']>;
  /** Tax withholding type */
  taxWithholdingType?: Maybe<SettlementTaxWithholdingTypeEnum>;
  /** Ticket deal lines */
  ticketDeals?: Maybe<Array<SettlementDeal>>;
  /** When the settlement was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** An event a settlement can be based on */
export type SettlementEvent = {
  __typename?: 'SettlementEvent';
  /** Calendar date of the event */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Doors-open time */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Show end time */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the event */
  id: Scalars['Int']['output'];
  /** Name of the event */
  name?: Maybe<Scalars['String']['output']>;
  /** Show start time */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lifecycle state of the event */
  state?: Maybe<EventStateEnum>;
  /** IANA timezone of the event */
  timezone?: Maybe<Scalars['String']['output']>;
};

/** A deal line on an artist settlement */
export type SettlementDeal = {
  __typename?: 'SettlementDeal';
  /** Marks the deal for removal on save */
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  /** Flat amount for the deal */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Attachments on the deal */
  attachments?: Maybe<Array<SettlementAttachment>>;
  /** When the deal was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Underlying deal template */
  deal?: Maybe<Deal>;
  /** DEPRECATED */
  dealId?: Maybe<Scalars['Int']['output']>;
  /** Deal structure key */
  dealType?: Maybe<DealEnum>;
  /** Expense amount applied to the deal */
  expenseAmount?: Maybe<Scalars['Float']['output']>;
  /** First-threshold amount for the deal */
  firstAmount?: Maybe<Scalars['Float']['output']>;
  /** Hit-threshold amount for the deal */
  hitAmount?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the deal line */
  id: Scalars['Int']['output'];
  /** Percentage for the deal */
  percent?: Maybe<Scalars['Float']['output']>;
  /** Whether to show ticket sales for the deal */
  showTicketSales?: Maybe<Scalars['Boolean']['output']>;
  /** When the deal was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** An attachment on a settlement payment, deal, or tax detail */
export type SettlementAttachment = {
  __typename?: 'SettlementAttachment';
  /** Unique identifier for the attachment, when persisted */
  id?: Maybe<Scalars['Int']['output']>;
  /** File name of the attachment */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Download URL for the attachment */
  url?: Maybe<Scalars['String']['output']>;
};

/** A deal template used to calculate an artist settlement line */
export type Deal = {
  __typename?: 'Deal';
  /** Formula used to calculate the deal */
  calculation: Scalars['String']['output'];
  /** Human-readable explanation of the deal */
  comment: Scalars['String']['output'];
  /** When the deal was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the deal */
  id: Scalars['Int']['output'];
  /** Deal structure key */
  key: DealEnum;
  /** Name of the deal */
  name: Scalars['String']['output'];
  /** When the deal was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Deal structure used to calculate an offer sheet */
export enum DealEnum {
  /** Artist Guarantee */
  ArtistGuarantee = 'artist_guarantee',
  /** Artist Guarantee plus. GBOR after Expenses */
  ArtistGuaranteePlusGborAfterExpenses = 'artist_guarantee_plus_gbor_after_expenses',
  /** Artist Guarantee vs GBOR */
  ArtistGuaranteeVsGbor = 'artist_guarantee_vs_gbor',
  /** Artist Guarantee vs GBOR after Expenses */
  ArtistGuaranteeVsGborAfterExpenses = 'artist_guarantee_vs_gbor_after_expenses',
  /** Flat fee to artist */
  FlatFee = 'flat_fee',
  /** GBOR */
  Gbor = 'gbor',
  /** GBOR after expenses */
  GborAfterExpenses = 'gbor_after_expenses',
  /** Bar Guarantee due to Venue */
  GuaranteeToVenue = 'guarantee_to_venue',
  /** None */
  None = 'none',
  /** % of F&B sales if F&B exceeds amount after amount */
  PercentAfterHit = 'percent_after_hit',
  /** % of F&B sales if F&B exceeds amount */
  PercentWithHit = 'percent_with_hit',
  /** Rental fee to Venue */
  Rental = 'rental',
  /** % of F&B sales */
  SalesPercentage = 'sales_percentage'
}

/** A custom expense line on an artist settlement */
export type SettlementCustomExpense = {
  __typename?: 'SettlementCustomExpense';
  /** Marks the expense for removal on save */
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  /** Amount of the expense */
  amount?: Maybe<Scalars['Float']['output']>;
  /** When the expense was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Deducted from net or gross */
  deductedType?: Maybe<CustomExpenseDeductedTypeEnum>;
  /** Description of the expense */
  description?: Maybe<Scalars['String']['output']>;
  /** Party the expense is due to */
  due?: Maybe<CustomExpenseDueEnum>;
  /** Unique identifier for the expense */
  id: Scalars['Int']['output'];
  /** When the expense was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Whether a custom settlement expense is deducted from net or gross */
export enum CustomExpenseDeductedTypeEnum {
  /** Deducted from gross */
  Gross = 'GROSS',
  /** Deducted from net */
  Net = 'NET'
}

/** Party a custom settlement expense is due to */
export enum CustomExpenseDueEnum {
  /** Amount due to the artist */
  ToArtist = 'TO_ARTIST',
  /** Amount due to the venue */
  ToVenue = 'TO_VENUE'
}

/** A manually entered ticket-sales line on an artist settlement */
export type SettlementManualTicketSale = {
  __typename?: 'SettlementManualTicketSale';
  /** Marks the row for removal on save */
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  /** When the row was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Description of the manual ticket sale */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the row */
  id: Scalars['Int']['output'];
  /** Ticket price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Number of tickets sold */
  ticketsSold?: Maybe<Scalars['Int']['output']>;
  /** When the row was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A payment recorded against an artist settlement */
export type SettlementPayment = {
  __typename?: 'SettlementPayment';
  /** Marks the payment for removal on save */
  _destroy?: Maybe<Scalars['Boolean']['output']>;
  /** Amount of the payment */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Attachments on the payment */
  attachments?: Maybe<Array<SettlementAttachment>>;
  /** Check or wire reference number */
  checkWireNr?: Maybe<Scalars['String']['output']>;
  /** When the payment was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date the payment is due */
  dateDue?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date the payment was made */
  datePaid?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the payment */
  id: Scalars['Int']['output'];
  /** Who the payment was made to */
  payee?: Maybe<Scalars['String']['output']>;
  /** Method of payment */
  paymentType?: Maybe<PaymentTypeEnum>;
  /** When the payment was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Method used to pay an artist settlement payment */
export enum PaymentTypeEnum {
  /** Cash */
  Cash = 'CASH',
  /** Check */
  Check = 'CHECK',
  /** Credit card */
  CreditCard = 'CREDIT_CARD',
  /** No payment method specified */
  None = 'NONE',
  /** Wire transfer */
  WireTransfer = 'WIRE_TRANSFER'
}

/** How an artist settlement is calculated */
export enum SettlementTypeEnum {
  /** Settlement based on a manual ticket-sales entry */
  ManualGbor = 'MANUAL_GBOR',
  /** Settlement based on ticket sales at selected events in the event group */
  TicketSalesEvents = 'TICKET_SALES_EVENTS'
}

/** A signed contract attached to a settlement */
export type SettlementContract = {
  __typename?: 'SettlementContract';
  /** File name of the signed contract */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Download URL for the signed contract */
  url?: Maybe<Scalars['String']['output']>;
};

/** How tax withholding on a settlement is expressed */
export enum SettlementTaxWithholdingTypeEnum {
  /** Withholding expressed as a fixed amount */
  Fixed = 'FIXED',
  /** Withholding expressed as a percentage */
  Percentage = 'PERCENTAGE'
}

/** EventGroupArtistCollection type */
export type EventGroupArtistCollection = {
  __typename?: 'EventGroupArtistCollection';
  /** A collection of paginated EventGroupArtistCollection */
  collection: Array<EventGroupArtist>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

export type EventGroupArtist = {
  __typename?: 'EventGroupArtist';
  artist: Artist;
  /** Artist of this entry; with eventGroupId it identifies the entry */
  artistId: Scalars['Int']['output'];
  /** Event group of this entry; with artistId it identifies the entry */
  eventGroupId: Scalars['Int']['output'];
  /**
   * ID of the event group's link row for this artist
   * @deprecated Identify an entry by its (eventGroupId, artistId) pair
   */
  id: Scalars['Int']['output'];
  /** Legacy event artist, used for compatibility with settlement sheets */
  legacyEventArtistId?: Maybe<Scalars['Int']['output']>;
  /**
   * Legacy offer sheet ID
   * @deprecated Use offerSheetId
   */
  legacyOfferSheetId?: Maybe<Scalars['Int']['output']>;
  /**
   * Legacy settlement sheet ID
   * @deprecated Use eventArtistSettlements(eventGroupId:, artistId:)
   */
  legacySettlementSheetId?: Maybe<Scalars['Int']['output']>;
  /** ID of the artist's current offer sheet for this event group */
  offerSheetId?: Maybe<Scalars['Int']['output']>;
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** The connection type for EventSummary. */
export type EventSummaryConnection = {
  __typename?: 'EventSummaryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventSummaryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total events matching the filter, ignoring pagination (first/after). Backs the numbered paginator and the range-truncation warning. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventSummaryEdge = {
  __typename?: 'EventSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventSummary>;
};

export type FeaturePreview = {
  __typename?: 'FeaturePreview';
  enabled: Scalars['Boolean']['output'];
  feature: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Label that can be attached to events and user roles */
export type Label = {
  __typename?: 'Label';
  /** Id of the label */
  id: Scalars['Int']['output'];
  /** Name of the label */
  name: Scalars['String']['output'];
};

/** A Looker Studio report available to the account */
export type Report = {
  __typename?: 'Report';
  /** Human-readable report name */
  name: Scalars['String']['output'];
  /**
   * Always null
   * @deprecated The report slug in reportId identifies the page
   */
  pageId?: Maybe<Scalars['String']['output']>;
  /** Report slug, e.g. ticket-manifest */
  reportId: Scalars['String']['output'];
};

/** User information */
export type User = {
  __typename?: 'User';
  /** Whether the user has ever signed in (a support signal for login issues) */
  active: Scalars['Boolean']['output'];
  /** List of API keys associated with the user */
  apiKeys?: Maybe<Array<ApiKey>>;
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Unique identifier for the user */
  id: Scalars['ID']['output'];
  /** Name of the user */
  name?: Maybe<Scalars['String']['output']>;
  /** Passkeys registered by the user */
  webauthnCredentials: Array<WebauthnCredential>;
};

/** Date window to filter memos by overlap. */
export type MemoSearchArguments = {
  /** Start of the window in iso8601 format, eg. 2026-09-01 */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** End of the window in iso8601 format, eg. 2026-09-30 */
  dateTo?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Memo. */
export type MemoConnection = {
  __typename?: 'MemoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MemoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Memo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MemoEdge = {
  __typename?: 'MemoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Memo>;
};

/** A calendar memo belonging to an account. */
export type Memo = {
  __typename?: 'Memo';
  /** Name of the member who created the memo; null if that member was removed from the account */
  createdByName?: Maybe<Scalars['String']['output']>;
  /** Free-text description of the memo */
  description?: Maybe<Scalars['String']['output']>;
  /** Last day the memo covers */
  endDate: Scalars['ISO8601Date']['output'];
  /** The kind of memo; null when unset */
  icon?: Maybe<MemoIconEnum>;
  /** Id of the memo */
  id: Scalars['Int']['output'];
  /** First day the memo covers */
  startDate: Scalars['ISO8601Date']['output'];
  /** Title of the memo */
  title: Scalars['String']['output'];
};

/** The kind of a memo, naming its category rather than a glyph. */
export enum MemoIconEnum {
  Delivery = 'DELIVERY',
  Holiday = 'HOLIDAY',
  Maintenance = 'MAINTENANCE',
  Note = 'NOTE',
  OutOfOffice = 'OUT_OF_OFFICE'
}

/** An offer sheet with its financial detail, projected sales and versions */
export type Sheet = {
  __typename?: 'Sheet';
  /** Booking agent for the offer */
  agent?: Maybe<Agent>;
  /** Name of the artist the offer is for */
  artistName?: Maybe<Scalars['String']['output']>;
  /** Projected total attendees (tickets plus lists) */
  attendeeCount?: Maybe<Scalars['Int']['output']>;
  /** Billing terms for the offer */
  billing?: Maybe<Scalars['String']['output']>;
  /** Contacts associated with the offer */
  contacts?: Maybe<Array<OfferSheetContact>>;
  /** Guaranteed amount paid to the artist */
  dealArtistGuarantee?: Maybe<Scalars['Float']['output']>;
  /** Artist percentage of gross box office revenue */
  dealGborPercentage?: Maybe<Scalars['Float']['output']>;
  /** Deal structure for the offer */
  dealType?: Maybe<DealEnum>;
  /** Doors-open time */
  doorTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Show end time */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Identifier of the event group the offer belongs to */
  eventGroupId?: Maybe<Scalars['Int']['output']>;
  /** Exclusivity terms for the offer */
  exclusivity?: Maybe<Scalars['String']['output']>;
  /** Expense categories on the offer */
  expenseCategories?: Maybe<Array<ExpenseCategory>>;
  /** Guaranteed amount paid to the headliner */
  headlinerGuarantee?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the offer sheet */
  id: Scalars['Int']['output'];
  /** Projected number of list attendees */
  listCount?: Maybe<Scalars['Int']['output']>;
  /** Attendee lists on the offer */
  lists?: Maybe<Array<List>>;
  /** When the offer sheet was locked */
  lockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User who locked the offer sheet */
  lockedBy?: Maybe<User>;
  /** Merchandise terms for the offer */
  merch?: Maybe<Scalars['String']['output']>;
  /** Minimum attendee age for the event */
  minimumAge?: Maybe<Scalars['Int']['output']>;
  /** Name of the offer sheet */
  name?: Maybe<Scalars['String']['output']>;
  /** Free-form note on the offer */
  note?: Maybe<Scalars['String']['output']>;
  /** Date the offer was made */
  offerDate: Scalars['ISO8601Date']['output'];
  /** Date the offer expires */
  offerExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Human-readable summary of performance dates */
  performanceDatesDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the promoter */
  promoterName?: Maybe<Scalars['String']['output']>;
  /** Promoter profit percentage */
  promoterProfitPercentage?: Maybe<Scalars['Float']['output']>;
  /** Show start time */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Calculated financial summary for the offer */
  summary?: Maybe<Summary>;
  /** Support act terms for the offer */
  support?: Maybe<Scalars['String']['output']>;
  /** Guaranteed amount paid to the support act */
  supportGuarantee?: Maybe<Scalars['Float']['output']>;
  /** Tax percentage applied to the offer */
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  /** Projected number of tickets sold */
  ticketCount?: Maybe<Scalars['Int']['output']>;
  /** Projected ticket allotments on the offer */
  tickets?: Maybe<Array<OfferTicket>>;
  /** Address of the venue */
  venueAddress?: Maybe<Scalars['String']['output']>;
  /** Logo URL of the venue */
  venueLogo?: Maybe<Scalars['String']['output']>;
  /** Name of the venue */
  venueName?: Maybe<Scalars['String']['output']>;
  /** Timezone of the venue */
  venueTimezone?: Maybe<Scalars['String']['output']>;
  /** Saved versions of the offer sheet */
  versions?: Maybe<Array<SheetVersion>>;
};

/** Booking agent associated with an offer sheet */
export type Agent = {
  __typename?: 'Agent';
  /** Name of the agency the agent represents */
  agencyName?: Maybe<Scalars['String']['output']>;
  /** Email address of the agent */
  email?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the agent */
  id?: Maybe<Scalars['Int']['output']>;
  /** Name of the agent */
  name?: Maybe<Scalars['String']['output']>;
};

/** A contact person associated with an offer sheet */
export type OfferSheetContact = {
  __typename?: 'OfferSheetContact';
  /** When the contact was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email address of the contact */
  email: Scalars['String']['output'];
  /** Unique identifier for the contact */
  id: Scalars['Int']['output'];
  /** Name of the contact */
  name: Scalars['String']['output'];
  /** Role of the contact on the offer */
  role: Scalars['String']['output'];
  /** When the contact was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A category grouping related offer sheet expenses */
export type ExpenseCategory = {
  __typename?: 'ExpenseCategory';
  /** Whether the category can be edited (no automatic expenses present) */
  editable: Scalars['Boolean']['output'];
  /** Expenses within this category */
  expenses: Array<Expense>;
  /** Unique identifier for the expense category */
  id: Scalars['Int']['output'];
  /** Name of the expense category */
  name: Scalars['String']['output'];
  /** Sum of all expenses in this category */
  totalExpenses: Scalars['Float']['output'];
  /** Whether this category holds variable expenses */
  variable: Scalars['Boolean']['output'];
};

/** A single expense line within an offer sheet expense category */
export type Expense = {
  __typename?: 'Expense';
  /** Monetary amount of the expense */
  amount?: Maybe<Scalars['Float']['output']>;
  /** How a variable expense is calculated */
  calculationType?: Maybe<VariableExpenseEnum>;
  /** Value used by the calculation type */
  calculationValue?: Maybe<Scalars['Float']['output']>;
  /** Whether the expense can be edited (manual expenses only) */
  editable: Scalars['Boolean']['output'];
  /** Unique identifier for the expense */
  id: Scalars['Int']['output'];
  /** Name of the expense */
  name: Scalars['String']['output'];
};

/** Calculation method for a variable expense */
export enum VariableExpenseEnum {
  /** % of GBOR */
  GborPercentage = 'gbor_percentage',
  /** Per Attendee */
  PerAttendee = 'per_attendee',
  /** Per ticket */
  PerTicket = 'per_ticket'
}

/** An attendee list (guest or paid) on an offer sheet */
export type List = {
  __typename?: 'List';
  /** Validation errors for the list, if any */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** Projected gross revenue for the list */
  gross: Scalars['Float']['output'];
  /** Unique identifier for the list */
  id?: Maybe<Scalars['Int']['output']>;
  /** Type of the list */
  listType: ListTypeEnum;
  /** Name of the list */
  name: Scalars['String']['output'];
  /** Projected number of attendees on the list */
  projected: Scalars['Int']['output'];
};

/** Type of an offer sheet attendee list */
export enum ListTypeEnum {
  /** Guest list */
  GuestList = 'guest_list',
  /** Paid list */
  PaidList = 'paid_list'
}

/** Calculated financial summary for an offer sheet */
export type Summary = {
  __typename?: 'Summary';
  /** Artist backend earnings */
  artistBackend?: Maybe<Scalars['Float']['output']>;
  /** Potential artist earnings */
  artistPotential?: Maybe<Scalars['Float']['output']>;
  /** Breakeven attendance */
  breakeven?: Maybe<Scalars['Float']['output']>;
  /** Total fixed expenses */
  fixedExpenses?: Maybe<Scalars['Float']['output']>;
  /** Gross box office revenue */
  gbor?: Maybe<Scalars['Float']['output']>;
  /** Net potential revenue */
  netPotential?: Maybe<Scalars['Float']['output']>;
  /** Revenue above the split point */
  overage?: Maybe<Scalars['Float']['output']>;
  /** Potential promoter earnings */
  promoterPotential?: Maybe<Scalars['Float']['output']>;
  /** Promoter profit */
  promoterProfit?: Maybe<Scalars['Float']['output']>;
  /** Revenue split point */
  splitPoint?: Maybe<Scalars['Float']['output']>;
  /** Calculated tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
  /** Total of fixed and variable expenses */
  totalExpenses?: Maybe<Scalars['Float']['output']>;
  /** Total variable expenses */
  variableExpenses?: Maybe<Scalars['Float']['output']>;
};

/** A projected ticket allotment on an offer sheet */
export type OfferTicket = {
  __typename?: 'OfferTicket';
  /** Projected gross revenue for the ticket */
  gross: Scalars['Float']['output'];
  /** Unique identifier for the offer ticket */
  id: Scalars['Int']['output'];
  /** Name of the ticket */
  name: Scalars['String']['output'];
  /** Price per ticket */
  price: Scalars['Float']['output'];
  /** Projected number of tickets sold */
  projected: Scalars['Int']['output'];
  /** Seating section for the ticket */
  section?: Maybe<Scalars['String']['output']>;
};

/** A saved version of an offer sheet */
export type SheetVersion = {
  __typename?: 'SheetVersion';
  /** Unique identifier for the offer sheet version */
  id: Scalars['Int']['output'];
  /** Sequential version number */
  version: Scalars['Int']['output'];
  /** Human-readable name for the version */
  versionName?: Maybe<Scalars['String']['output']>;
};

/** A reusable offer sheet template */
export type Template = {
  __typename?: 'Template';
  /** Unique identifier for the template */
  id: Scalars['Int']['output'];
  /** Name of the template */
  templateName: Scalars['String']['output'];
};

/** Represents an order in the system, full details */
export type OrderDetails = {
  __typename?: 'OrderDetails';
  /** The account associated with the order */
  account: AccountSummary;
  /** Store credit applied to the order (null when none) */
  appliedCredit?: Maybe<Scalars['Float']['output']>;
  /** Card brand used for the order (from cc_type); null for non-card payments */
  cardBrand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Currency code of the order */
  currency: Scalars['String']['output'];
  /** The customer associated with the order */
  customer?: Maybe<Customer>;
  /** Discount amount applied to the order */
  discountAmount: Scalars['Float']['output'];
  /** Discount code applied to the order */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** Discount ID applied to the order */
  discountId?: Maybe<Scalars['Int']['output']>;
  /** Donation amount applied to the order */
  donation: Scalars['Float']['output'];
  /** The order's own contact email; not the global customer record */
  email?: Maybe<Scalars['String']['output']>;
  /** The event associated with the order */
  event?: Maybe<Event>;
  /** Unique fingerprint of the order */
  fingerprint: Scalars['String']['output'];
  /** The order's own contact first name; not the global customer record */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the order */
  id: Scalars['Int']['output'];
  /** Last four digits of the credit card used for the order */
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  /** The order's own contact last name; not the global customer record */
  lastName?: Maybe<Scalars['String']['output']>;
  /** List of line items in the order */
  lineItems: Array<LineItem>;
  /** The source of the order */
  origin: OrderOriginEnum;
  /** Payment method used for the order */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** The order's own contact phone number; not the global customer record */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Platform fee charged for the order, in the order currency (see `currency`). Matches the platform fee sent to Stripe. */
  platformFee: Scalars['Float']['output'];
  /** Processing fee charged for the order */
  processingFee: Scalars['Float']['output'];
  /** Timestamp when the order was purchased */
  purchasedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total amount refunded across all refunds on the order */
  refundedAmount: Scalars['Float']['output'];
  /** The order's refunds, oldest first */
  refunds: Array<Refund>;
  /** Computed refund status of the order (none/partial/full) */
  refundStatus: RefundStatusEnum;
  /** Number of tickets scanned */
  scannedCount: Scalars['Int']['output'];
  /** Staff user who made this box-office sale; null for online/imported orders */
  soldBy?: Maybe<PublicUser>;
  /** Current state of the order */
  state: Scalars['String']['output'];
  /** Tax fee charged for the order */
  taxFee: Scalars['Float']['output'];
  /** Total number of tickets purchased */
  ticketCount: Scalars['Int']['output'];
  /** Resolved FGL layout string for the order */
  ticketLayout?: Maybe<Scalars['String']['output']>;
  /** Total amount of the order */
  total: Scalars['Float']['output'];
  /** Transaction ID associated with the order payment */
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Line item in an order */
export type LineItem = {
  __typename?: 'LineItem';
  /** Net amount retained on the line item (discounted price + fee, less refunds) */
  balance: Scalars['Float']['output'];
  /** Whether the line item is claimable */
  claimable: Scalars['Boolean']['output'];
  /** Fee for the line item */
  fee: Scalars['Float']['output'];
  /** First name of the ticket holder */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the line item */
  id: Scalars['Int']['output'];
  /** Whether the line item is a ticket or an add-on */
  kind: LineItemKindEnum;
  /** Last name of the ticket holder */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Name of the line item */
  name: Scalars['String']['output'];
  /** Gross amount paid by the customer for the line item (price + fee, before refunds) */
  paid: Scalars['Float']['output'];
  /** HTML preview URL for the ticket (distinct from the pdfUrl download) */
  pdfPreviewUrl?: Maybe<Scalars['String']['output']>;
  /** URL to the ticket PDF */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Price for the line item */
  price: Scalars['Float']['output'];
  /** Whether the line item has been used */
  scanned: Scalars['Boolean']['output'];
  /** List of scan events for the line item */
  scans: Array<LineItemScan>;
  /** Seat number for the line item */
  seat?: Maybe<Scalars['String']['output']>;
  /** Table number for the line item */
  table?: Maybe<Scalars['String']['output']>;
  /** Identifier of the underlying ticket record */
  ticketId: Scalars['Int']['output'];
  /** Ticket tier/type name (e.g. "GA: Tier 1") */
  tier?: Maybe<Scalars['String']['output']>;
  /** Unique token for the line item */
  token: Scalars['String']['output'];
};

export enum LineItemKindEnum {
  Addon = 'addon',
  Ticket = 'ticket'
}

/** Type representing a ticket scan event */
export type LineItemScan = {
  __typename?: 'LineItemScan';
  /** Date and time when the ticket was scanned */
  scannedAt: Scalars['ISO8601DateTime']['output'];
  /** User who scanned the ticket */
  scannedBy?: Maybe<PublicUser>;
};

/** A refund issued against an order */
export type Refund = {
  __typename?: 'Refund';
  /** Total amount refunded */
  amount: Scalars['Float']['output'];
  /** When the refund was issued */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Donation amount refunded */
  donation: Scalars['Float']['output'];
  /** Unique identifier for the refund */
  id: Scalars['Int']['output'];
  /** Name of the user who issued the refund */
  issuedBy?: Maybe<Scalars['String']['output']>;
  /** Whether the refund was partial or full */
  kind: RefundKindEnum;
  /** Refunded tickets, grouped by ticket type and amount */
  lines: Array<RefundLine>;
  /** Processing fee refunded */
  processingFee: Scalars['Float']['output'];
  /** Reason given for the refund */
  reason?: Maybe<Scalars['String']['output']>;
  /** Tax refunded */
  taxFee: Scalars['Float']['output'];
};

/** Whether a refund returned part of the order or all of it */
export enum RefundKindEnum {
  Full = 'full',
  Partial = 'partial'
}

/** Tickets of one type refunded at the same amount within a refund */
export type RefundLine = {
  __typename?: 'RefundLine';
  /** Amount refunded for these tickets, including the platform fee */
  amount: Scalars['Float']['output'];
  /** Name of the event the tickets were for */
  eventName?: Maybe<Scalars['String']['output']>;
  /** Number of tickets refunded */
  quantity: Scalars['Int']['output'];
  /** Table or seat labels of the refunded tickets; null for unseated events */
  seatLabels?: Maybe<Array<Scalars['String']['output']>>;
  /** Name of the refunded ticket type */
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

export type OrderSearchArguments = {
  /** Filter orders created after this date/time */
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Filter orders created before this date/time */
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** List of Event IDs to filter orders by. */
  eventIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter orders by (partial) fingerprint */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by platform */
  origin?: InputMaybe<Array<OrderOriginEnum>>;
  /** Filter orders by payment method */
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** General search query to filter orders */
  q?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by the staff user(s) who made the sale */
  soldByUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter orders by state */
  state?: InputMaybe<Array<OrderStateEnum>>;
};

export enum OrderStateEnum {
  AwaitingPayment = 'awaiting_payment',
  Completed = 'completed',
  Draft = 'draft'
}

export type Organization = {
  __typename?: 'Organization';
  /** Indicates if this is the user's default account */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier of the account */
  id: Scalars['Int']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
};

/** The connection type for SeatingChart. */
export type SeatingChartConnection = {
  __typename?: 'SeatingChartConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SeatingChartEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SeatingChart>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SeatingChartEdge = {
  __typename?: 'SeatingChartEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SeatingChart>;
};

/** Seats.io configuration for the current account */
export type SeatsIoConfig = {
  __typename?: 'SeatsIoConfig';
  /** Seats.io workspace public key */
  publicKey: Scalars['String']['output'];
  /** Seats.io region identifier */
  region: Scalars['String']['output'];
  /** Seats.io workspace secret key */
  secretKey: Scalars['String']['output'];
};

/** Full team role definition, including permission groups and allowances */
export type TeamRoleDetails = {
  __typename?: 'TeamRoleDetails';
  allowances: Array<Allowance>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissionGroups: Array<PermissionGroup>;
};

/** A team role grouping a set of account permissions */
export type TeamRole = {
  __typename?: 'TeamRole';
  /** Unique identifier for the team role */
  id: Scalars['Int']['output'];
  /** Display name of the team role */
  name: Scalars['String']['output'];
};

/** Attributes to create or update a ticket. Omitted fields are left unchanged on update */
export type TicketBlueprintAttributes = {
  /** Tickets this row may sell on its own; null sells to the section limit */
  allotment?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the ticket can be sold during a presale. Recomputed from presale links whenever a presale is saved */
  availableOnPresale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ticket whose sale closing puts this one on sale; only with the dependency sale trigger */
  dependencyId?: InputMaybe<Scalars['Int']['input']>;
  /** Description shown to buyers */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Discounts that apply to this ticket. Omit (or send null) to keep the current discounts; an empty list removes all, making the ticket eligible for none */
  discountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the event the ticket belongs to */
  eventId: Scalars['Int']['input'];
  /** Per-ticket fee added to the price */
  fee?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the ticket to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the ticket is admission or an add-on */
  kind?: InputMaybe<TicketBlueprintKind>;
  /** Most tickets a buyer can purchase in one order */
  maximum?: InputMaybe<Scalars['Int']['input']>;
  /** Fewest tickets a buyer can purchase in one order */
  minimum?: InputMaybe<Scalars['Int']['input']>;
  /** Tickets must be purchased in multiples of this number */
  multiple?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the ticket */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Face value of the ticket */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** What puts the ticket on sale. Required on create, and whenever sellStart or dependencyId is sent */
  saleTrigger?: InputMaybe<TicketSaleTrigger>;
  /** Section this ticket draws its allotment from; null when self-allotted */
  sectionId?: InputMaybe<Scalars['Int']['input']>;
  /** Channels the ticket is sold through */
  sellableThrough?: InputMaybe<Array<TicketSellableThrough>>;
  /** When this ticket stops selling */
  sellEnd?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** When this ticket goes on sale; only with the window sale trigger */
  sellStart?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** What puts a ticket on sale */
export enum TicketSaleTrigger {
  /** Goes on sale when the ticket named by dependencyId stops selling */
  Dependency = 'dependency',
  /** Sells between sellStart and sellEnd */
  Window = 'window'
}

/** What a buyer pays for one ticket, fee by fee */
export type TicketPricingBreakdown = {
  __typename?: 'TicketPricingBreakdown';
  /** Credit-card processing fee */
  ccFee: Scalars['Float']['output'];
  /** Price shown to the buyer, including the fees the venue folds into it */
  displayPrice: Scalars['Float']['output'];
  /** VenuePilot platform fee */
  platformFee: Scalars['Float']['output'];
  /** Face value of the ticket */
  price: Scalars['Float']['output'];
  /** Sales tax */
  taxFee: Scalars['Float']['output'];
  /** Per-ticket fee as charged; zero on a free ticket */
  venueFee: Scalars['Float']['output'];
};

/** A sellable ticket type (blueprint) for an event, for the discount and presale pickers */
export type EventTicketType = {
  __typename?: 'EventTicketType';
  /** Internal numeric ID of the ticket type */
  id: Scalars['Int']['output'];
  /** Display name of the ticket type */
  name: Scalars['String']['output'];
  /** When this ticket type stops selling */
  sellEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this ticket type goes on sale */
  sellStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for UserAccount. */
export type UserAccountConnection = {
  __typename?: 'UserAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserAccountEdge = {
  __typename?: 'UserAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserAccount>;
};

/** A user's membership in an account (team member) */
export type UserAccount = {
  __typename?: 'UserAccount';
  /** Unique identifier for the user account */
  id: Scalars['Int']['output'];
  /** Coarse account role (admin/owner) */
  role?: Maybe<Scalars['String']['output']>;
  /** Team role granting this member their permissions */
  teamRole?: Maybe<TeamRole>;
  /** The user this membership belongs to */
  user: User;
};

/** The connection type for WebhookDeliveryAttempt. */
export type WebhookDeliveryAttemptConnection = {
  __typename?: 'WebhookDeliveryAttemptConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WebhookDeliveryAttemptEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WebhookDeliveryAttempt>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type WebhookDeliveryAttemptEdge = {
  __typename?: 'WebhookDeliveryAttemptEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WebhookDeliveryAttempt>;
};

/** One attempt to deliver a webhook to a subscription; carries no payload and no response body */
export type WebhookDeliveryAttempt = {
  __typename?: 'WebhookDeliveryAttempt';
  /** Which attempt this was for the delivery, starting at 1 */
  attempt: Scalars['Int']['output'];
  /** When the attempt was made */
  attemptedAt: Scalars['ISO8601DateTime']['output'];
  /** How long the attempt took, in milliseconds */
  durationMs: Scalars['Int']['output'];
  /** Why no status code was received: timeout, connection_failed or delivery_error */
  failureKind?: Maybe<Scalars['String']['output']>;
  /** The attempt id */
  id: Scalars['Int']['output'];
  /** The idempotency key sent with the delivery */
  idempotencyKey: Scalars['String']['output'];
  /** The id of the record the delivery concerned */
  recordId: Scalars['Int']['output'];
  /** The HTTP status code returned, if any response was received */
  responseStatus?: Maybe<Scalars['Int']['output']>;
  /** The topic delivered */
  topic: Scalars['String']['output'];
};

/** An outbound webhook subscription for an account */
export type WebhookSubscription = {
  __typename?: 'WebhookSubscription';
  /** When it was paused automatically; null unless paused */
  autoPausedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why it was paused automatically: how many deliveries failed since when, and with what responses; null unless paused */
  autoPauseReason?: Maybe<Scalars['String']['output']>;
  /** Whether the viewer may change this subscription or rotate its secret: only its owner can, with edit access to webhooks */
  canEdit: Scalars['Boolean']['output'];
  /** Whether the viewer may take ownership of this subscription: a signed-in member with edit access to webhooks whose own access covers its topics and hold opt-in; false for its current owner */
  canTakeOwnership: Scalars['Boolean']['output'];
  /** Whether it is delivering now; when it is not, status says why */
  delivering: Scalars['Boolean']['output'];
  /** The HTTPS URL deliveries are POSTed to */
  destinationUrl: Scalars['String']['output'];
  /** The subscription id */
  id: Scalars['Int']['output'];
  /** Whether hold events are delivered to this subscription */
  includeHolds: Scalars['Boolean']['output'];
  /** Whose access the subscription uses: a team member or an API key */
  owner: WebhookSubscriptionOwner;
  /** When the previous signing secret stops co-signing deliveries after a rotation; null when no rotation window is open */
  previousSecretExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the subscription is delivering */
  status: WebhookSubscriptionStatusEnum;
  /** The topics this subscription receives */
  topics: Array<Scalars['String']['output']>;
};

/** Whose access a webhook subscription uses */
export type WebhookSubscriptionOwner = {
  __typename?: 'WebhookSubscriptionOwner';
  /** Whether the owner is a team member or an API key */
  kind: WebhookSubscriptionOwnerKindEnum;
  /** The member's or the key's name; null when the owner is gone or was never named */
  name?: Maybe<Scalars['String']['output']>;
  /** False once the owner is gone (key revoked, member removed); status says whether the subscription still delivers */
  present: Scalars['Boolean']['output'];
};

/** Whether a webhook subscription uses a team member's access or an API key's */
export enum WebhookSubscriptionOwnerKindEnum {
  /** An API key; the subscription uses the key's access, capped by its owner's role */
  ApiKey = 'api_key',
  /** A member of the account's team; the subscription uses their role's access */
  TeamMember = 'team_member'
}

export enum WebhookSubscriptionStatusEnum {
  /** Switched on; delivers while the account has the webhooks feature and its principal has access */
  Active = 'active',
  /** Switched off by an operator; stays off until an operator switches it back on */
  Disabled = 'disabled',
  /** Stopped automatically after sustained delivery failures; stays off until an operator switches it back on */
  Paused = 'paused',
  /** Stopped because its principal lost access; resumes when that access is restored */
  Suspended = 'suspended'
}

/** Configuration for an embeddable ticket widget */
export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  /** Widget configuration payload */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** When the widget configuration was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Human-readable description of the widget configuration */
  description: Scalars['String']['output'];
  /** URL used to embed the widget */
  embedUrl?: Maybe<Scalars['String']['output']>;
  /** Id of the widget configuration */
  id: Scalars['Int']['output'];
  /** URL of the widget loader script */
  loaderUrl?: Maybe<Scalars['String']['output']>;
  /** Custom styling for the widget */
  style?: Maybe<Scalars['String']['output']>;
  /** Unique token identifying the widget configuration */
  token?: Maybe<Scalars['String']['output']>;
  /** When the widget configuration was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WidgetConfigSearchArguments = {
  /** General search query matching the widget configuration description */
  q?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for WidgetConfig. */
export type WidgetConfigConnection = {
  __typename?: 'WidgetConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WidgetConfigEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WidgetConfig>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total widget configurations for the account, ignoring pagination. Backs a numbered paginator and the "showing N of M" label. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WidgetConfigEdge = {
  __typename?: 'WidgetConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WidgetConfig>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  bcc?: Maybe<Array<Scalars['String']['output']>>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  templateType: EmailTemplateTypeEnum;
};

export enum EmailTemplateTypeEnum {
  WillCall = 'WILL_CALL'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Add an artist to an event */
  addEventArtist?: Maybe<AddEventArtistMutationPayload>;
  /** Add an artist to an event group (and its events) */
  addEventGroupArtist?: Maybe<AddEventGroupArtistMutationPayload>;
  /** Overwrite an offer sheet's contents from a template */
  applyOfferSheetTemplate?: Maybe<ApplyTemplateMutationPayload>;
  /** Archive an artist settlement instead of deleting it */
  archiveEventArtistSettlement?: Maybe<ArchiveSettlementMutationPayload>;
  /** Archive a seating chart */
  archiveSeatingChart?: Maybe<ArchiveSeatingChartMutationPayload>;
  /** Cancel a confirmed event and start refunding its orders */
  cancelEvent?: Maybe<CancelEventMutationPayload>;
  /** Confirm a S3 attachment upload is complete */
  confirmAttachmentUpload?: Maybe<ConfirmAttachmentUploadMutationPayload>;
  /** Link a VenuePilot event to a Prism.fm event */
  connectPrismEvent?: Maybe<ConnectPrismEventMutationPayload>;
  /** Convert a ticket hold into a sellable ticket, keeping its id */
  convertHoldToTicket?: Maybe<ConvertHoldToTicketMutationPayload>;
  /** Create a new API key for the currently logged in user */
  createApiKey?: Maybe<CreateApiKeyMutationPayload>;
  /** Create a customer credit on the current account */
  createCustomerCredit?: Maybe<CreateCustomerCreditMutationPayload>;
  /** Create an attachment and get a presigned S3 upload URL */
  createDirectUploadUrl?: Maybe<CreateDirectUploadUrlMutationPayload>;
  /** Create an empty settlement for an artist in an event group */
  createEventArtistSettlement?: Maybe<CreateSettlementMutationPayload>;
  /** Add an attachment to an event artist settlement payment, deal, or tax detail */
  createEventArtistSettlementAttachment?: Maybe<CreateEventArtistSettlementAttachmentMutationPayload>;
  /** Create hold events grouped in an event group */
  createHolds?: Maybe<CreateHoldsMutationPayload>;
  /** Copy an offer sheet into a new reusable template */
  createOfferSheetTemplate?: Maybe<CreateTemplateMutationPayload>;
  /** Snapshot an offer sheet as a new saved version */
  createOfferSheetVersion?: Maybe<CreateSheetVersionMutationPayload>;
  /** Create an outbound webhook subscription for the current account */
  createWebhookSubscription?: Maybe<CreateWebhookSubscriptionMutationPayload>;
  /** Delete a discount */
  deleteDiscount?: Maybe<DeleteDiscountMutationPayload>;
  /** Delete an email schedule */
  deleteEmailSchedule?: Maybe<DeleteEmailScheduleMutationPayload>;
  /** Delete an email template */
  deleteEmailTemplate?: Maybe<DeleteEmailTemplateMutationPayload>;
  /** Remove an attachment from an event artist settlement payment, deal, or tax detail */
  deleteEventArtistSettlementAttachment?: Maybe<DeleteEventArtistSettlementAttachmentMutationPayload>;
  /** Delete a guest list and its entries */
  deleteGuestList?: Maybe<DeleteGuestListMutationPayload>;
  /** Delete a label */
  deleteLabel?: Maybe<DeleteLabelMutationPayload>;
  /** Delete a memo */
  deleteMemo?: Maybe<DeleteMemoMutationPayload>;
  /** Delete a contact from an offer sheet */
  deleteOfferContact?: Maybe<DeleteContactMutationPayload>;
  /** Delete an expense line from an offer sheet */
  deleteOfferExpense?: Maybe<DeleteExpenseMutationPayload>;
  /** Delete an expense category from an offer sheet */
  deleteOfferExpenseCategory?: Maybe<DeleteExpenseCategoryMutationPayload>;
  /** Delete an attendee list from an offer sheet */
  deleteOfferList?: Maybe<DeleteListMutationPayload>;
  /** Delete a ticket line from an offer sheet */
  deleteOfferTicket?: Maybe<DeleteTicketMutationPayload>;
  /** Delete a presale */
  deletePresale?: Maybe<DeletePresaleMutationPayload>;
  /** Permanently delete a seating chart */
  deleteSeatingChart?: Maybe<DeleteSeatingChartMutationPayload>;
  /** Delete a team role */
  deleteTeamRole?: Maybe<DeleteTeamRoleMutationPayload>;
  /** Delete a ticket from an event */
  deleteTicketBlueprint?: Maybe<DeleteTicketBlueprintMutationPayload>;
  /** Delete a ticket hold */
  deleteTicketHold?: Maybe<DeleteTicketHoldMutationPayload>;
  /** Delete an empty ticket section from an event */
  deleteTicketSection?: Maybe<DeleteTicketSectionMutationPayload>;
  /** Delete a user account */
  deleteUserAccount?: Maybe<DeleteUserAccountMutationPayload>;
  /** Delete a venue */
  deleteVenue?: Maybe<DeleteVenueMutationPayload>;
  /** Soft-delete one of the current user's passkey credentials */
  deleteWebauthnCredential?: Maybe<DeleteWebauthnCredentialMutationPayload>;
  /** Delete an outbound webhook subscription from the current account */
  deleteWebhookSubscription?: Maybe<DeleteWebhookSubscriptionMutationPayload>;
  /** Delete a widget configuration */
  deleteWidget?: Maybe<DeleteWidgetMutationPayload>;
  /** Unlink a VenuePilot event from Prism.fm */
  disconnectPrismEvent?: Maybe<DisconnectPrismEventMutationPayload>;
  /** Duplicate a seating chart */
  duplicateSeatingChart?: Maybe<DuplicateSeatingChartMutationPayload>;
  /** Generate the canceled event's refund report CSV as a private export */
  exportCancellationReport?: Maybe<ExportCancellationReportMutationPayload>;
  /** Generate the event's daily sales CSV as a private export */
  exportSales?: Maybe<ExportSalesMutationPayload>;
  /** Generate the event's will-call CSV as a private export */
  exportWillCallList?: Maybe<ExportWillCallListMutationPayload>;
  /** Regenerate an offer sheet's performance-dates summary */
  generateOfferSheetPerformanceDates?: Maybe<GeneratePerformanceDatesMutationPayload>;
  /** Generate (or regenerate) the settlement sheet PDF via VP Press */
  generateSettlementPdf?: Maybe<GenerateSettlementPdfMutationPayload>;
  /** Return options for signing in with a passkey */
  generateWebauthnAuthenticationOptions?: Maybe<GenerateWebauthnAuthenticationOptionsMutationPayload>;
  /** Return options for registering a new passkey */
  generateWebauthnRegistrationOptions?: Maybe<GenerateWebauthnRegistrationOptionsMutationPayload>;
  /** Import guests from CSV text into a guest list in the background */
  importGuestList?: Maybe<ImportGuestListMutationPayload>;
  /** Lock an offer sheet, stashing a rendered PDF attachment */
  lockOfferSheet?: Maybe<LockSheetMutationPayload>;
  /** Regenerate the shareable report link for an event, invalidating the previous one */
  regenerateShareableReportLink?: Maybe<RegenerateShareableReportLinkMutationPayload>;
  /** Verify an attestation and persist the new passkey credential */
  registerWebauthnCredential?: Maybe<RegisterWebauthnCredentialMutationPayload>;
  /** Remove an artist from an event */
  removeEventArtist?: Maybe<RemoveEventArtistMutationPayload>;
  /** Remove an artist from an event group (and its events) */
  removeEventGroupArtist?: Maybe<RemoveEventGroupArtistMutationPayload>;
  /** Remove the seating chart assignment from an event */
  removeSeatingChart?: Maybe<RemoveSeatingChartMutationPayload>;
  /** Reorder artists for an event */
  reorderEventArtists?: Maybe<ReorderEventArtistsMutationPayload>;
  /** Reorder the tickets of an event */
  reorderTicketBlueprints?: Maybe<ReorderTicketBlueprintsMutationPayload>;
  /** Resend a scheduled report to a chosen set of recipients */
  resendEmailSchedule?: Maybe<ResendEmailScheduleMutationPayload>;
  /** Resend the purchase-confirmation email for an order */
  resendOrderConfirmation?: Maybe<ResendOrderConfirmationMutationPayload>;
  /** Permanently revoke one of the current user's API keys */
  revokeApiKey?: Maybe<RevokeApiKeyMutationPayload>;
  /** Rotate one of the current user's API keys, retiring the old one at once */
  rotateApiKey?: Maybe<RotateApiKeyMutationPayload>;
  /** Rotate a webhook subscription's signing secret; the old one co-signs for a grace window */
  rotateWebhookSubscriptionSecret?: Maybe<RotateWebhookSubscriptionSecretMutationPayload>;
  /** Create or update the announce detail for an event */
  saveAnnounceDetail?: Maybe<SaveAnnounceDetailMutationPayload>;
  /** Create or update an artist */
  saveArtist?: Maybe<SaveArtistMutationPayload>;
  /** Create or update the default set for a venue */
  saveDefaultSet?: Maybe<SaveDefaultSetMutationPayload>;
  /** Create or update a discount */
  saveDiscount?: Maybe<SaveDiscountMutationPayload>;
  /** Create or update an email schedule */
  saveEmailSchedule?: Maybe<SaveEmailScheduleMutationPayload>;
  /** Create or update an email template */
  saveEmailTemplate?: Maybe<SaveEmailTemplateMutationPayload>;
  /** Create or update an event */
  saveEvent?: Maybe<SaveEventMutationPayload>;
  /** Create or update a rider for an event artist */
  saveEventArtistRider?: Maybe<SaveEventArtistRiderMutationPayload>;
  /** Create or update a guest list and its entries */
  saveGuestList?: Maybe<SaveGuestListMutationPayload>;
  /** Create or update a label */
  saveLabel?: Maybe<SaveLabelMutationPayload>;
  /** Create or update a memo */
  saveMemo?: Maybe<SaveMemoMutationPayload>;
  /** Create or update a presale */
  savePresale?: Maybe<SavePresaleMutationPayload>;
  /** Replace the custom expense lines on an artist settlement */
  saveSettlementCustomExpenses?: Maybe<SaveSettlementCustomExpensesMutationPayload>;
  /** Replace the deal lines on an artist settlement */
  saveSettlementDeals?: Maybe<SaveSettlementDealsMutationPayload>;
  /** Set the events an artist settlement is based on */
  saveSettlementEvents?: Maybe<SaveSettlementEventsMutationPayload>;
  /** Replace the manual ticket-sale lines on a settlement */
  saveSettlementManualTicketSales?: Maybe<SaveSettlementManualTicketSalesMutationPayload>;
  /** Replace the payment lines on an artist settlement */
  saveSettlementPayments?: Maybe<SaveSettlementPaymentsMutationPayload>;
  /** Update the tax, business and payee-address section of a settlement */
  saveSettlementTaxDetails?: Maybe<SaveSettlementTaxDetailsMutationPayload>;
  /** Create or update a team role */
  saveTeamRole?: Maybe<SaveTeamRoleMutationPayload>;
  /** Create or update a ticket for an event */
  saveTicketBlueprint?: Maybe<SaveTicketBlueprintMutationPayload>;
  /** Create or update a ticket hold for an event */
  saveTicketHold?: Maybe<SaveTicketHoldMutationPayload>;
  /** Create or update a ticket section for an event */
  saveTicketSection?: Maybe<SaveTicketSectionMutationPayload>;
  /** Update the currently logged-in user's own profile */
  saveUser?: Maybe<SaveUserMutationPayload>;
  /** Create or update a user account (team member) */
  saveUserAccount?: Maybe<SaveUserAccountMutationPayload>;
  /** Create or update a venue */
  saveVenue?: Maybe<SaveVenueMutationPayload>;
  /** Create or update a widget configuration */
  saveWidget?: Maybe<SaveWidgetMutationPayload>;
  /** Assign a seating chart to an event */
  selectSeatingChart?: Maybe<SelectSeatingChartMutationPayload>;
  /** Resend the invitation/welcome email for a user account */
  sendUserAccountInvitation?: Maybe<SendUserAccountInvitationMutationPayload>;
  /** Send will call emails to customers */
  sendWillCallEmails?: Maybe<SendWillCallEmailsMutationPayload>;
  /** Add or remove labels to an event */
  setEventLabels?: Maybe<SetEventLabelsMutationPayload>;
  /** Enable or disable a feature preview for the current account */
  setFeaturePreview?: Maybe<SetFeaturePreviewMutationPayload>;
  /** Add or remove labels to a user account */
  setUserAccountLabels?: Maybe<SetUserAccountLabelsMutationPayload>;
  /** Switch a webhook subscription's delivery off or back on */
  setWebhookSubscriptionDelivery?: Maybe<SetWebhookSubscriptionDeliveryMutationPayload>;
  /** Verify a passkey assertion and establish a user session */
  signinWithPasskey?: Maybe<SigninWithPasskeyMutationPayload>;
  /** Sync an artist from Soundcharts */
  syncArtist?: Maybe<SyncArtistMutationPayload>;
  /** Manually sync ticket sales data to Prism.fm */
  syncPrismSales?: Maybe<SyncPrismSalesMutationPayload>;
  /** Sync a seating chart from seats.io to the local database */
  syncSeatingChart?: Maybe<SyncSeatingChartMutationPayload>;
  /** Make the signed-in member a webhook subscription's principal, re-authorising it */
  takeWebhookSubscriptionOwnership?: Maybe<TakeWebhookSubscriptionOwnershipMutationPayload>;
  /** Trigger the Zapier artist_push event for an event group artist */
  triggerArtistZapier?: Maybe<TriggerArtistZapierMutationPayload>;
  /** Trigger the Zapier artist_push event for an artist on an event */
  triggerEventArtistZapier?: Maybe<TriggerEventArtistZapierMutationPayload>;
  /** Update an offer sheet header and financial detail */
  updateOfferSheet?: Maybe<UpdateSheetMutationPayload>;
  /** Update an order's customer/pickup contact */
  updateOrderCustomer?: Maybe<UpdateOrderCustomerMutationPayload>;
  /** Update a webhook subscription; only its principal may change it */
  updateWebhookSubscription?: Maybe<UpdateWebhookSubscriptionMutationPayload>;
  /** Create or update a contact on an offer sheet */
  upsertOfferContact?: Maybe<UpsertContactMutationPayload>;
  /** Create or update an expense line on an offer sheet */
  upsertOfferExpense?: Maybe<UpsertExpenseMutationPayload>;
  /** Create or update an expense category on an offer sheet */
  upsertOfferExpenseCategory?: Maybe<UpsertExpenseCategoryMutationPayload>;
  /** Create or update an attendee list on an offer sheet */
  upsertOfferList?: Maybe<UpsertListMutationPayload>;
  /** Create or assign the booking agent on an offer sheet */
  upsertOfferSheetAgent?: Maybe<UpsertAgentMutationPayload>;
  /** Create or update a ticket line on an offer sheet */
  upsertOfferTicket?: Maybe<UpsertTicketMutationPayload>;
};


export type MutationAddEventArtistArgs = {
  input: AddEventArtistMutationInput;
};


export type MutationAddEventGroupArtistArgs = {
  input: AddEventGroupArtistMutationInput;
};


export type MutationApplyOfferSheetTemplateArgs = {
  input: ApplyTemplateMutationInput;
};


export type MutationArchiveEventArtistSettlementArgs = {
  input: ArchiveSettlementMutationInput;
};


export type MutationArchiveSeatingChartArgs = {
  input: ArchiveSeatingChartMutationInput;
};


export type MutationCancelEventArgs = {
  input: CancelEventMutationInput;
};


export type MutationConfirmAttachmentUploadArgs = {
  input: ConfirmAttachmentUploadMutationInput;
};


export type MutationConnectPrismEventArgs = {
  input: ConnectPrismEventMutationInput;
};


export type MutationConvertHoldToTicketArgs = {
  input: ConvertHoldToTicketMutationInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyMutationInput;
};


export type MutationCreateCustomerCreditArgs = {
  input: CreateCustomerCreditMutationInput;
};


export type MutationCreateDirectUploadUrlArgs = {
  input: CreateDirectUploadUrlMutationInput;
};


export type MutationCreateEventArtistSettlementArgs = {
  input: CreateSettlementMutationInput;
};


export type MutationCreateEventArtistSettlementAttachmentArgs = {
  input: CreateEventArtistSettlementAttachmentMutationInput;
};


export type MutationCreateHoldsArgs = {
  input: CreateHoldsMutationInput;
};


export type MutationCreateOfferSheetTemplateArgs = {
  input: CreateTemplateMutationInput;
};


export type MutationCreateOfferSheetVersionArgs = {
  input: CreateSheetVersionMutationInput;
};


export type MutationCreateWebhookSubscriptionArgs = {
  input: CreateWebhookSubscriptionMutationInput;
};


export type MutationDeleteDiscountArgs = {
  input: DeleteDiscountMutationInput;
};


export type MutationDeleteEmailScheduleArgs = {
  input: DeleteEmailScheduleMutationInput;
};


export type MutationDeleteEmailTemplateArgs = {
  input: DeleteEmailTemplateMutationInput;
};


export type MutationDeleteEventArtistSettlementAttachmentArgs = {
  input: DeleteEventArtistSettlementAttachmentMutationInput;
};


export type MutationDeleteGuestListArgs = {
  input: DeleteGuestListMutationInput;
};


export type MutationDeleteLabelArgs = {
  input: DeleteLabelMutationInput;
};


export type MutationDeleteMemoArgs = {
  input: DeleteMemoMutationInput;
};


export type MutationDeleteOfferContactArgs = {
  input: DeleteContactMutationInput;
};


export type MutationDeleteOfferExpenseArgs = {
  input: DeleteExpenseMutationInput;
};


export type MutationDeleteOfferExpenseCategoryArgs = {
  input: DeleteExpenseCategoryMutationInput;
};


export type MutationDeleteOfferListArgs = {
  input: DeleteListMutationInput;
};


export type MutationDeleteOfferTicketArgs = {
  input: DeleteTicketMutationInput;
};


export type MutationDeletePresaleArgs = {
  input: DeletePresaleMutationInput;
};


export type MutationDeleteSeatingChartArgs = {
  input: DeleteSeatingChartMutationInput;
};


export type MutationDeleteTeamRoleArgs = {
  input: DeleteTeamRoleMutationInput;
};


export type MutationDeleteTicketBlueprintArgs = {
  input: DeleteTicketBlueprintMutationInput;
};


export type MutationDeleteTicketHoldArgs = {
  input: DeleteTicketHoldMutationInput;
};


export type MutationDeleteTicketSectionArgs = {
  input: DeleteTicketSectionMutationInput;
};


export type MutationDeleteUserAccountArgs = {
  input: DeleteUserAccountMutationInput;
};


export type MutationDeleteVenueArgs = {
  input: DeleteVenueMutationInput;
};


export type MutationDeleteWebauthnCredentialArgs = {
  input: DeleteWebauthnCredentialMutationInput;
};


export type MutationDeleteWebhookSubscriptionArgs = {
  input: DeleteWebhookSubscriptionMutationInput;
};


export type MutationDeleteWidgetArgs = {
  input: DeleteWidgetMutationInput;
};


export type MutationDisconnectPrismEventArgs = {
  input: DisconnectPrismEventMutationInput;
};


export type MutationDuplicateSeatingChartArgs = {
  input: DuplicateSeatingChartMutationInput;
};


export type MutationExportCancellationReportArgs = {
  input: ExportCancellationReportMutationInput;
};


export type MutationExportSalesArgs = {
  input: ExportSalesMutationInput;
};


export type MutationExportWillCallListArgs = {
  input: ExportWillCallListMutationInput;
};


export type MutationGenerateOfferSheetPerformanceDatesArgs = {
  input: GeneratePerformanceDatesMutationInput;
};


export type MutationGenerateSettlementPdfArgs = {
  input: GenerateSettlementPdfMutationInput;
};


export type MutationGenerateWebauthnAuthenticationOptionsArgs = {
  input: GenerateWebauthnAuthenticationOptionsMutationInput;
};


export type MutationGenerateWebauthnRegistrationOptionsArgs = {
  input: GenerateWebauthnRegistrationOptionsMutationInput;
};


export type MutationImportGuestListArgs = {
  input: ImportGuestListMutationInput;
};


export type MutationLockOfferSheetArgs = {
  input: LockSheetMutationInput;
};


export type MutationRegenerateShareableReportLinkArgs = {
  input: RegenerateShareableReportLinkMutationInput;
};


export type MutationRegisterWebauthnCredentialArgs = {
  input: RegisterWebauthnCredentialMutationInput;
};


export type MutationRemoveEventArtistArgs = {
  input: RemoveEventArtistMutationInput;
};


export type MutationRemoveEventGroupArtistArgs = {
  input: RemoveEventGroupArtistMutationInput;
};


export type MutationRemoveSeatingChartArgs = {
  input: RemoveSeatingChartMutationInput;
};


export type MutationReorderEventArtistsArgs = {
  input: ReorderEventArtistsMutationInput;
};


export type MutationReorderTicketBlueprintsArgs = {
  input: ReorderTicketBlueprintsMutationInput;
};


export type MutationResendEmailScheduleArgs = {
  input: ResendEmailScheduleMutationInput;
};


export type MutationResendOrderConfirmationArgs = {
  input: ResendOrderConfirmationMutationInput;
};


export type MutationRevokeApiKeyArgs = {
  input: RevokeApiKeyMutationInput;
};


export type MutationRotateApiKeyArgs = {
  input: RotateApiKeyMutationInput;
};


export type MutationRotateWebhookSubscriptionSecretArgs = {
  input: RotateWebhookSubscriptionSecretMutationInput;
};


export type MutationSaveAnnounceDetailArgs = {
  input: SaveAnnounceDetailMutationInput;
};


export type MutationSaveArtistArgs = {
  input: SaveArtistMutationInput;
};


export type MutationSaveDefaultSetArgs = {
  input: SaveDefaultSetMutationInput;
};


export type MutationSaveDiscountArgs = {
  input: SaveDiscountMutationInput;
};


export type MutationSaveEmailScheduleArgs = {
  input: SaveEmailScheduleMutationInput;
};


export type MutationSaveEmailTemplateArgs = {
  input: SaveEmailTemplateMutationInput;
};


export type MutationSaveEventArgs = {
  input: SaveEventMutationInput;
};


export type MutationSaveEventArtistRiderArgs = {
  input: SaveEventArtistRiderMutationInput;
};


export type MutationSaveGuestListArgs = {
  input: SaveGuestListMutationInput;
};


export type MutationSaveLabelArgs = {
  input: SaveLabelMutationInput;
};


export type MutationSaveMemoArgs = {
  input: SaveMemoMutationInput;
};


export type MutationSavePresaleArgs = {
  input: SavePresaleMutationInput;
};


export type MutationSaveSettlementCustomExpensesArgs = {
  input: SaveSettlementCustomExpensesMutationInput;
};


export type MutationSaveSettlementDealsArgs = {
  input: SaveSettlementDealsMutationInput;
};


export type MutationSaveSettlementEventsArgs = {
  input: SaveSettlementEventsMutationInput;
};


export type MutationSaveSettlementManualTicketSalesArgs = {
  input: SaveSettlementManualTicketSalesMutationInput;
};


export type MutationSaveSettlementPaymentsArgs = {
  input: SaveSettlementPaymentsMutationInput;
};


export type MutationSaveSettlementTaxDetailsArgs = {
  input: SaveSettlementTaxDetailsMutationInput;
};


export type MutationSaveTeamRoleArgs = {
  input: SaveTeamRoleMutationInput;
};


export type MutationSaveTicketBlueprintArgs = {
  input: SaveTicketBlueprintMutationInput;
};


export type MutationSaveTicketHoldArgs = {
  input: SaveTicketHoldMutationInput;
};


export type MutationSaveTicketSectionArgs = {
  input: SaveTicketSectionMutationInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserMutationInput;
};


export type MutationSaveUserAccountArgs = {
  input: SaveUserAccountMutationInput;
};


export type MutationSaveVenueArgs = {
  input: SaveVenueMutationInput;
};


export type MutationSaveWidgetArgs = {
  input: SaveWidgetMutationInput;
};


export type MutationSelectSeatingChartArgs = {
  input: SelectSeatingChartMutationInput;
};


export type MutationSendUserAccountInvitationArgs = {
  input: SendUserAccountInvitationMutationInput;
};


export type MutationSendWillCallEmailsArgs = {
  input: SendWillCallEmailsMutationInput;
};


export type MutationSetEventLabelsArgs = {
  input: SetEventLabelsMutationInput;
};


export type MutationSetFeaturePreviewArgs = {
  input: SetFeaturePreviewMutationInput;
};


export type MutationSetUserAccountLabelsArgs = {
  input: SetUserAccountLabelsMutationInput;
};


export type MutationSetWebhookSubscriptionDeliveryArgs = {
  input: SetWebhookSubscriptionDeliveryMutationInput;
};


export type MutationSigninWithPasskeyArgs = {
  input: SigninWithPasskeyMutationInput;
};


export type MutationSyncArtistArgs = {
  input: SyncArtistMutationInput;
};


export type MutationSyncPrismSalesArgs = {
  input: SyncPrismSalesMutationInput;
};


export type MutationSyncSeatingChartArgs = {
  input: SyncSeatingChartMutationInput;
};


export type MutationTakeWebhookSubscriptionOwnershipArgs = {
  input: TakeWebhookSubscriptionOwnershipMutationInput;
};


export type MutationTriggerArtistZapierArgs = {
  input: TriggerArtistZapierMutationInput;
};


export type MutationTriggerEventArtistZapierArgs = {
  input: TriggerEventArtistZapierMutationInput;
};


export type MutationUpdateOfferSheetArgs = {
  input: UpdateSheetMutationInput;
};


export type MutationUpdateOrderCustomerArgs = {
  input: UpdateOrderCustomerMutationInput;
};


export type MutationUpdateWebhookSubscriptionArgs = {
  input: UpdateWebhookSubscriptionMutationInput;
};


export type MutationUpsertOfferContactArgs = {
  input: UpsertContactMutationInput;
};


export type MutationUpsertOfferExpenseArgs = {
  input: UpsertExpenseMutationInput;
};


export type MutationUpsertOfferExpenseCategoryArgs = {
  input: UpsertExpenseCategoryMutationInput;
};


export type MutationUpsertOfferListArgs = {
  input: UpsertListMutationInput;
};


export type MutationUpsertOfferSheetAgentArgs = {
  input: UpsertAgentMutationInput;
};


export type MutationUpsertOfferTicketArgs = {
  input: UpsertTicketMutationInput;
};

/** Autogenerated input type of AddEventArtistMutation */
export type AddEventArtistMutationInput = {
  /** Artist to add to the event */
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to which the artist will be added */
  eventId: Scalars['Int']['input'];
};

export type ArtistInput = {
  attachments?: InputMaybe<Array<ArtistAttachmentInput>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  links?: InputMaybe<Array<ArtistLinkInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformUrl?: InputMaybe<Scalars['String']['input']>;
  soundchartsUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ArtistAttachmentInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentId: Scalars['Int']['input'];
};

export type ArtistLinkInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  url: Scalars['String']['input'];
};

/** Autogenerated return type of AddEventArtistMutation. */
export type AddEventArtistMutationPayload = {
  __typename?: 'AddEventArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the mutation fails */
  errors?: Maybe<Scalars['JSON']['output']>;
  /** The event artist that was added to the event */
  eventArtist?: Maybe<EventArtist>;
  /** Indicates whether the artist was successfully added to the event */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddEventGroupArtistMutation */
export type AddEventGroupArtistMutationInput = {
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventGroupId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddEventGroupArtistMutation. */
export type AddEventGroupArtistMutationPayload = {
  __typename?: 'AddEventGroupArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  eventGroupArtist?: Maybe<EventGroupArtist>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ApplyTemplateMutation */
export type ApplyTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to overwrite */
  offerSheetId: Scalars['Int']['input'];
  /** ID of the template to apply */
  templateId: Scalars['Int']['input'];
};

/** Autogenerated return type of ApplyTemplateMutation. */
export type ApplyTemplateMutationPayload = {
  __typename?: 'ApplyTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

export type VpError = {
  __typename?: 'VpError';
  /** Full error message */
  message: Scalars['String']['output'];
  /** Path to the field that caused the error, or `base` */
  path?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ArchiveSettlementMutation */
export type ArchiveSettlementMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the settlement to archive */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveSettlementMutation. */
export type ArchiveSettlementMutationPayload = {
  __typename?: 'ArchiveSettlementMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveSeatingChartMutation */
export type ArchiveSeatingChartMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the seating chart to archive */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of ArchiveSeatingChartMutation. */
export type ArchiveSeatingChartMutationPayload = {
  __typename?: 'ArchiveSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CancelEventMutation */
export type CancelEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to cancel */
  eventId: Scalars['Int']['input'];
  /** Optional completion-channel id for a live broadcast; poll canceledEvent */
  jobUuid?: InputMaybe<Scalars['String']['input']>;
  /** `refund_choose` offers customers credit; anything else refunds in full */
  refundPolicy: Scalars['String']['input'];
  /** Keep the credit card fee when refunding */
  retainCcFee?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CancelEventMutation. */
export type CancelEventMutationPayload = {
  __typename?: 'CancelEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the cancellation was refused, if it was */
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of ConfirmAttachmentUploadMutation */
export type ConfirmAttachmentUploadMutationInput = {
  /** ID of the attachment to confirm */
  attachmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConfirmAttachmentUploadMutation. */
export type ConfirmAttachmentUploadMutationPayload = {
  __typename?: 'ConfirmAttachmentUploadMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the mutation failed */
  errors?: Maybe<Array<VpError>>;
  /** Indicates if the upload was confirmed */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConnectPrismEventMutation */
export type ConnectPrismEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** VenuePilot event ID */
  eventId: Scalars['Int']['input'];
  /** Prism.fm event ID to link */
  prismEventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ConnectPrismEventMutation. */
export type ConnectPrismEventMutationPayload = {
  __typename?: 'ConnectPrismEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The updated event */
  event?: Maybe<Event>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConvertHoldToTicketMutation */
export type ConvertHoldToTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the resulting ticket */
  ticketBlueprint: TicketBlueprintAttributes;
  /** The hold to convert */
  ticketHoldId: Scalars['Int']['input'];
};

/** Autogenerated return type of ConvertHoldToTicketMutation. */
export type ConvertHoldToTicketMutationPayload = {
  __typename?: 'ConvertHoldToTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the hold was not converted */
  errors?: Maybe<Array<VpError>>;
  /** The converted ticket */
  ticketBlueprint?: Maybe<TicketBlueprint>;
};

/** Autogenerated input type of CreateApiKeyMutation */
export type CreateApiKeyMutationInput = {
  /** Attributes for the new API key */
  apiKey: ApiKeyAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAttributes = {
  /** Account the key is scoped to */
  accountId: Scalars['Int']['input'];
  /** Expiry; defaults to and is capped at 1 year */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Permission set the key grants */
  permission: ApiKeyPermissionAttributes;
};

/** Permission levels and allowances the API key grants */
export type ApiKeyPermissionAttributes = {
  add_artist?: InputMaybe<Scalars['Boolean']['input']>;
  add_hold?: InputMaybe<Scalars['Boolean']['input']>;
  artists__financials?: InputMaybe<Scalars['String']['input']>;
  artists__hospitality_rider?: InputMaybe<Scalars['String']['input']>;
  artists__stats_sheet?: InputMaybe<Scalars['String']['input']>;
  artists__tech_rider?: InputMaybe<Scalars['String']['input']>;
  box_office_app?: InputMaybe<Scalars['Boolean']['input']>;
  budget__actual_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__actual_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__actual_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__projected_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__projected_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__projected_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__shared_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__summary?: InputMaybe<Scalars['String']['input']>;
  budget__template?: InputMaybe<Scalars['String']['input']>;
  cancel_event?: InputMaybe<Scalars['Boolean']['input']>;
  closeout_sheet__access?: InputMaybe<Scalars['String']['input']>;
  closeout_sheet__manual_tickets?: InputMaybe<Scalars['String']['input']>;
  confirm_date?: InputMaybe<Scalars['Boolean']['input']>;
  customers__credits?: InputMaybe<Scalars['String']['input']>;
  download_will_call?: InputMaybe<Scalars['Boolean']['input']>;
  event_details__announce?: InputMaybe<Scalars['String']['input']>;
  event_details__audit_log?: InputMaybe<Scalars['String']['input']>;
  event_details__canceled_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__confirmed_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__deleted_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__hold_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__name?: InputMaybe<Scalars['String']['input']>;
  event_details__notes?: InputMaybe<Scalars['String']['input']>;
  other__artists?: InputMaybe<Scalars['String']['input']>;
  other__event_notes?: InputMaybe<Scalars['String']['input']>;
  other__memos?: InputMaybe<Scalars['String']['input']>;
  other__orders?: InputMaybe<Scalars['String']['input']>;
  other__projections?: InputMaybe<Scalars['String']['input']>;
  prism_fm?: InputMaybe<Scalars['Boolean']['input']>;
  reports__by_day?: InputMaybe<Scalars['String']['input']>;
  reports__by_email_opt_ins?: InputMaybe<Scalars['String']['input']>;
  reports__by_event_cancelation?: InputMaybe<Scalars['String']['input']>;
  reports__by_payment?: InputMaybe<Scalars['String']['input']>;
  sales_info__fees?: InputMaybe<Scalars['String']['input']>;
  sales_info__gbor?: InputMaybe<Scalars['String']['input']>;
  sales_info__number_sold?: InputMaybe<Scalars['String']['input']>;
  settings__integrations?: InputMaybe<Scalars['String']['input']>;
  settings__privileges?: InputMaybe<Scalars['String']['input']>;
  settings__team?: InputMaybe<Scalars['String']['input']>;
  settings__venues?: InputMaybe<Scalars['String']['input']>;
  settings__webhooks?: InputMaybe<Scalars['String']['input']>;
  ticketing__guest_list?: InputMaybe<Scalars['String']['input']>;
  ticketing__tickets?: InputMaybe<Scalars['String']['input']>;
  ticketing__will_call?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateApiKeyMutation. */
export type CreateApiKeyMutationPayload = {
  __typename?: 'CreateApiKeyMutationPayload';
  /** The newly created API key */
  apiKey: ApiKeyFull;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** API key with key unmasked */
export type ApiKeyFull = {
  __typename?: 'ApiKeyFull';
  /** The account the key is pinned to */
  account?: Maybe<AccountSummary>;
  /** Creation timestamp of the API key */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Expiration timestamp of the API key, if applicable */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the API key */
  id: Scalars['Int']['output'];
  /** The API key value (masked) */
  key: Scalars['String']['output'];
  /** The actual API key value */
  keyUnmasked: Scalars['String']['output'];
  /** The name of the key */
  name?: Maybe<Scalars['String']['output']>;
  /** The key's permission groups and allowances; null if the key has none */
  permissionSet?: Maybe<PermissionSet>;
  /** How many webhook subscriptions, in any status, use this key; revoking it suspends them. Null unless the viewer can read webhooks on the key's account */
  webhookSubscriptionCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of CreateCustomerCreditMutation */
export type CreateCustomerCreditMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for the customer credit */
  customerCredit: CustomerCreditAttributes;
  /** Customer email - auto-creates a top-level customer if no match exists */
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of an existing customer; takes precedence over `customerEmail` */
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for creating a customer credit */
export type CustomerCreditAttributes = {
  /** Credit amount (non-zero; negatives allowed) */
  amount: Scalars['Float']['input'];
  /** ISO currency code */
  currency: Scalars['String']['input'];
  /** Free-form description */
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCustomerCreditMutation. */
export type CreateCustomerCreditMutationPayload = {
  __typename?: 'CreateCustomerCreditMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerCredit?: Maybe<CustomerCredit>;
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of CreateDirectUploadUrlMutation */
export type CreateDirectUploadUrlMutationInput = {
  /** Checksum of the attachment */
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** What the upload is for, which picks the allowed file types. Omitted, any type allowed for either kind is accepted */
  kind?: InputMaybe<AttachmentKindEnum>;
  /** Name of the attachment */
  name: Scalars['String']['input'];
};

/** What an attachment upload is for, which decides the file types it accepts */
export enum AttachmentKindEnum {
  /** Settlement payment, deal and tax attachments, and riders: JPG, PNG, GIF, WebP, PDF, XLS, XLSX or CSV */
  Document = 'document',
  /** Venue, account, whitelabel, artist and announce images: JPG, PNG or WebP */
  Image = 'image'
}

/** Autogenerated return type of CreateDirectUploadUrlMutation. */
export type CreateDirectUploadUrlMutationPayload = {
  __typename?: 'CreateDirectUploadUrlMutationPayload';
  /** ID of the created attachment */
  attachmentId?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the mutation fails */
  errors?: Maybe<Array<VpError>>;
  /** Presigned S3 upload URL */
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSettlementMutation */
export type CreateSettlementMutationInput = {
  /** ID of the artist to settle */
  artistId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event group */
  eventGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSettlementMutation. */
export type CreateSettlementMutationPayload = {
  __typename?: 'CreateSettlementMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateEventArtistSettlementAttachmentMutation */
export type CreateEventArtistSettlementAttachmentMutationInput = {
  /** ID of the attachment to add */
  attachmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event artist deal */
  dealId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the event artist detail (for tax attachments) */
  eventArtistDetailId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the event artist payment */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateEventArtistSettlementAttachmentMutation. */
export type CreateEventArtistSettlementAttachmentMutationPayload = {
  __typename?: 'CreateEventArtistSettlementAttachmentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateHoldsMutation */
export type CreateHoldsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input specifying details for creating holds */
  createHolds: EventHoldInput;
};

/** Attributes for creating an event hold */
export type EventHoldInput = {
  /** ID of the event group to associate with the hold */
  eventGroupId?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Array<EventInput>>;
};

export type EventInput = {
  /** Whether donations are accepted for the event */
  availableForDonation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the event is subject to a processing fee */
  availableForProcessingFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the event is subject to sales tax */
  availableForSalesTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** Extra content for the confirmation email sent to attendees */
  confirmationEmailContent?: InputMaybe<Scalars['String']['input']>;
  /** Text shown on the donation button at checkout */
  donationButtonText?: InputMaybe<Scalars['String']['input']>;
  /** Description of what the donation supports */
  donationDescription?: InputMaybe<Scalars['String']['input']>;
  /** Door time of event in ISO 8601 format */
  doorTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** End time of the event in ISO 8601 format */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Footer content for the event tickets */
  footerContent?: InputMaybe<Scalars['String']['input']>;
  /** Hold preference for the event */
  holdPreference?: InputMaybe<Scalars['Int']['input']>;
  /** If provided, updates the existing event with this ID */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to generate PDF tickets and email them to attendees */
  mailPdfTickets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum age required to attend the event, 0 for all ages */
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the event */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Rich-text content shown on the order confirmation page */
  orderConfirmationContent?: InputMaybe<Scalars['String']['input']>;
  /** Whether will-call reminder emails are sent for this event */
  sendWillCallReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start time of the event in ISO 8601 format */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Maximum number of tickets that can be purchased in a single order */
  ticketLimit?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the venue where the event will take place */
  venueId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the room within the venue */
  venueRoomId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateHoldsMutation. */
export type CreateHoldsMutationPayload = {
  __typename?: 'CreateHoldsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors related to individual events creation */
  eventErrors?: Maybe<Array<Array<VpError>>>;
  /** The created event group with holds */
  eventGroup?: Maybe<EventGroup>;
  /** Errors related to the event group creation */
  eventGroupErrors?: Maybe<Array<VpError>>;
  /** Indicates if the holds were created successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTemplateMutation */
export type CreateTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to copy */
  offerSheetId: Scalars['Int']['input'];
  /** Name for the new template */
  templateName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTemplateMutation. */
export type CreateTemplateMutationPayload = {
  __typename?: 'CreateTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  template?: Maybe<Template>;
};

/** Autogenerated input type of CreateSheetVersionMutation */
export type CreateSheetVersionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to snapshot */
  id: Scalars['Int']['input'];
  /** Human-readable name for the new version */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSheetVersionMutation. */
export type CreateSheetVersionMutationPayload = {
  __typename?: 'CreateSheetVersionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  version: SheetVersion;
};

/** Autogenerated input type of CreateWebhookSubscriptionMutation */
export type CreateWebhookSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The absolute HTTPS URL deliveries are POSTed to */
  destinationUrl: Scalars['String']['input'];
  /** Deliver hold events to this subscription (operator opt-in) */
  includeHolds?: InputMaybe<Scalars['Boolean']['input']>;
  /** The topics to subscribe to */
  topics: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateWebhookSubscriptionMutation. */
export type CreateWebhookSubscriptionMutationPayload = {
  __typename?: 'CreateWebhookSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  webhookSubscription?: Maybe<WebhookSubscriptionFull>;
};

/** A webhook subscription with its signing secret unmasked */
export type WebhookSubscriptionFull = {
  __typename?: 'WebhookSubscriptionFull';
  /** When it was paused automatically; null unless paused */
  autoPausedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Why it was paused automatically: how many deliveries failed since when, and with what responses; null unless paused */
  autoPauseReason?: Maybe<Scalars['String']['output']>;
  /** Whether the viewer may change this subscription or rotate its secret: only its owner can, with edit access to webhooks */
  canEdit: Scalars['Boolean']['output'];
  /** Whether the viewer may take ownership of this subscription: a signed-in member with edit access to webhooks whose own access covers its topics and hold opt-in; false for its current owner */
  canTakeOwnership: Scalars['Boolean']['output'];
  /** Whether it is delivering now; when it is not, status says why */
  delivering: Scalars['Boolean']['output'];
  /** The HTTPS URL deliveries are POSTed to */
  destinationUrl: Scalars['String']['output'];
  /** The subscription id */
  id: Scalars['Int']['output'];
  /** Whether hold events are delivered to this subscription */
  includeHolds: Scalars['Boolean']['output'];
  /** Whose access the subscription uses: a team member or an API key */
  owner: WebhookSubscriptionOwner;
  /** When the previous signing secret stops co-signing deliveries after a rotation; null when no rotation window is open */
  previousSecretExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The HMAC signing secret. This is the only time it is returned; it is never readable again. After a rotation, X-Webhook-Signature lists one comma-separated signature per live secret until previousSecretExpiresAt; accept a delivery if any one matches. */
  signingSecret: Scalars['String']['output'];
  /** Whether the subscription is delivering */
  status: WebhookSubscriptionStatusEnum;
  /** The topics this subscription receives */
  topics: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteDiscountMutation */
export type DeleteDiscountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteDiscountMutation. */
export type DeleteDiscountMutationPayload = {
  __typename?: 'DeleteDiscountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteEmailScheduleMutation */
export type DeleteEmailScheduleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailScheduleId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteEmailScheduleMutation. */
export type DeleteEmailScheduleMutationPayload = {
  __typename?: 'DeleteEmailScheduleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteEmailTemplateMutation */
export type DeleteEmailTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailTemplateId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteEmailTemplateMutation. */
export type DeleteEmailTemplateMutationPayload = {
  __typename?: 'DeleteEmailTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteEventArtistSettlementAttachmentMutation */
export type DeleteEventArtistSettlementAttachmentMutationInput = {
  /** ID of the attachment to remove */
  attachmentId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event artist deal */
  dealId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the event artist detail (for tax attachments) */
  eventArtistDetailId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the event artist payment */
  paymentId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of DeleteEventArtistSettlementAttachmentMutation. */
export type DeleteEventArtistSettlementAttachmentMutationPayload = {
  __typename?: 'DeleteEventArtistSettlementAttachmentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteGuestListMutation */
export type DeleteGuestListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The guest list to delete */
  guestListId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteGuestListMutation. */
export type DeleteGuestListMutationPayload = {
  __typename?: 'DeleteGuestListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the guest list was not deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the guest list was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteLabelMutation */
export type DeleteLabelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  labelId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteLabelMutation. */
export type DeleteLabelMutationPayload = {
  __typename?: 'DeleteLabelMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMemoMutation */
export type DeleteMemoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the memo to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteMemoMutation. */
export type DeleteMemoMutationPayload = {
  __typename?: 'DeleteMemoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors preventing deletion, if any */
  errors?: Maybe<Array<VpError>>;
  /** Whether the memo was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteContactMutation */
export type DeleteContactMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteContactMutation. */
export type DeleteContactMutationPayload = {
  __typename?: 'DeleteContactMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteExpenseMutation */
export type DeleteExpenseMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the expense to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteExpenseMutation. */
export type DeleteExpenseMutationPayload = {
  __typename?: 'DeleteExpenseMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteExpenseCategoryMutation */
export type DeleteExpenseCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the expense category to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteExpenseCategoryMutation. */
export type DeleteExpenseCategoryMutationPayload = {
  __typename?: 'DeleteExpenseCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteListMutation */
export type DeleteListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the list to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteListMutation. */
export type DeleteListMutationPayload = {
  __typename?: 'DeleteListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeleteTicketMutation */
export type DeleteTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ticket to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTicketMutation. */
export type DeleteTicketMutationPayload = {
  __typename?: 'DeleteTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of DeletePresaleMutation */
export type DeletePresaleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeletePresaleMutation. */
export type DeletePresaleMutationPayload = {
  __typename?: 'DeletePresaleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteSeatingChartMutation */
export type DeleteSeatingChartMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the seating chart to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteSeatingChartMutation. */
export type DeleteSeatingChartMutationPayload = {
  __typename?: 'DeleteSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTeamRoleMutation */
export type DeleteTeamRoleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamRoleId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTeamRoleMutation. */
export type DeleteTeamRoleMutationPayload = {
  __typename?: 'DeleteTeamRoleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTicketBlueprintMutation */
export type DeleteTicketBlueprintMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ticket to delete */
  ticketBlueprintId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTicketBlueprintMutation. */
export type DeleteTicketBlueprintMutationPayload = {
  __typename?: 'DeleteTicketBlueprintMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the ticket was not deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the ticket was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTicketHoldMutation */
export type DeleteTicketHoldMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the hold to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTicketHoldMutation. */
export type DeleteTicketHoldMutationPayload = {
  __typename?: 'DeleteTicketHoldMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the hold was not deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the hold was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTicketSectionMutation */
export type DeleteTicketSectionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the section to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteTicketSectionMutation. */
export type DeleteTicketSectionMutationPayload = {
  __typename?: 'DeleteTicketSectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the section was not deleted */
  errors?: Maybe<Array<VpError>>;
  /** Whether the section was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserAccountMutation */
export type DeleteUserAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccountId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteUserAccountMutation. */
export type DeleteUserAccountMutationPayload = {
  __typename?: 'DeleteUserAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVenueMutation */
export type DeleteVenueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenueMutation. */
export type DeleteVenueMutationPayload = {
  __typename?: 'DeleteVenueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteWebauthnCredentialMutation */
export type DeleteWebauthnCredentialMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the passkey credential to delete */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteWebauthnCredentialMutation. */
export type DeleteWebauthnCredentialMutationPayload = {
  __typename?: 'DeleteWebauthnCredentialMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteWebhookSubscriptionMutation */
export type DeleteWebhookSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteWebhookSubscriptionMutation. */
export type DeleteWebhookSubscriptionMutationPayload = {
  __typename?: 'DeleteWebhookSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors preventing deletion, if any */
  errors?: Maybe<Array<VpError>>;
  /** Whether the subscription was deleted */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteWidgetMutation */
export type DeleteWidgetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteWidgetMutation. */
export type DeleteWidgetMutationPayload = {
  __typename?: 'DeleteWidgetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DisconnectPrismEventMutation */
export type DisconnectPrismEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** VenuePilot event ID to disconnect from Prism */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of DisconnectPrismEventMutation. */
export type DisconnectPrismEventMutationPayload = {
  __typename?: 'DisconnectPrismEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The updated event */
  event?: Maybe<Event>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DuplicateSeatingChartMutation */
export type DuplicateSeatingChartMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the seating chart to duplicate */
  id: Scalars['Int']['input'];
  /** Name for the duplicated chart */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DuplicateSeatingChartMutation. */
export type DuplicateSeatingChartMutationPayload = {
  __typename?: 'DuplicateSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The duplicated seating chart */
  seatingChart?: Maybe<SeatingChart>;
};

/** Autogenerated input type of ExportCancellationReportMutation */
export type ExportCancellationReportMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the canceled event to export the refund report for */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ExportCancellationReportMutation. */
export type ExportCancellationReportMutationPayload = {
  __typename?: 'ExportCancellationReportMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why no report was generated, if it was not */
  errors?: Maybe<Array<VpError>>;
  /** The cancellation export record */
  eventExport?: Maybe<EventExport>;
};

/** Autogenerated input type of ExportSalesMutation */
export type ExportSalesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to export daily sales for */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ExportSalesMutation. */
export type ExportSalesMutationPayload = {
  __typename?: 'ExportSalesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Generation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** The sales export record */
  eventExport?: Maybe<EventExport>;
};

/** Autogenerated input type of ExportWillCallListMutation */
export type ExportWillCallListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to export the will-call list for */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ExportWillCallListMutation. */
export type ExportWillCallListMutationPayload = {
  __typename?: 'ExportWillCallListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Generation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** The will-call export record */
  eventExport?: Maybe<EventExport>;
};

/** Autogenerated input type of GeneratePerformanceDatesMutation */
export type GeneratePerformanceDatesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to regenerate dates for */
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of GeneratePerformanceDatesMutation. */
export type GeneratePerformanceDatesMutationPayload = {
  __typename?: 'GeneratePerformanceDatesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of GenerateSettlementPdfMutation */
export type GenerateSettlementPdfMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If true, the PDF is regenerated even if one already exists */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the settlement to generate the PDF for */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of GenerateSettlementPdfMutation. */
export type GenerateSettlementPdfMutationPayload = {
  __typename?: 'GenerateSettlementPdfMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation or generation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** The settlement after generation */
  settlement?: Maybe<Settlement>;
  /** Whether the PDF was generated (or already present) */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateWebauthnAuthenticationOptionsMutation */
export type GenerateWebauthnAuthenticationOptionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateWebauthnAuthenticationOptionsMutation. */
export type GenerateWebauthnAuthenticationOptionsMutationPayload = {
  __typename?: 'GenerateWebauthnAuthenticationOptionsMutationPayload';
  /** Opaque handle for the cached challenge */
  challengeId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  /** JSON-encoded PublicKeyCredentialRequestOptions */
  optionsJson?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateWebauthnRegistrationOptionsMutation */
export type GenerateWebauthnRegistrationOptionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateWebauthnRegistrationOptionsMutation. */
export type GenerateWebauthnRegistrationOptionsMutationPayload = {
  __typename?: 'GenerateWebauthnRegistrationOptionsMutationPayload';
  /** Opaque handle for the cached challenge */
  challengeId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  /** JSON-encoded PublicKeyCredentialCreationOptions */
  optionsJson?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ImportGuestListMutation */
export type ImportGuestListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** CSV text, one guest per row: last name, first name, quantity; no header row */
  csv: Scalars['String']['input'];
  /** The guest list to import into */
  guestListId: Scalars['Int']['input'];
};

/** Autogenerated return type of ImportGuestListMutation. */
export type ImportGuestListMutationPayload = {
  __typename?: 'ImportGuestListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the import was not started */
  errors?: Maybe<Array<VpError>>;
  /** The import record, pending until done */
  eventExport?: Maybe<EventExport>;
};

/** Autogenerated input type of LockSheetMutation */
export type LockSheetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to lock */
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of LockSheetMutation. */
export type LockSheetMutationPayload = {
  __typename?: 'LockSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of RegenerateShareableReportLinkMutation */
export type RegenerateShareableReportLinkMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of RegenerateShareableReportLinkMutation. */
export type RegenerateShareableReportLinkMutationPayload = {
  __typename?: 'RegenerateShareableReportLinkMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of RegisterWebauthnCredentialMutation */
export type RegisterWebauthnCredentialMutationInput = {
  attestationResponseJson: Scalars['String']['input'];
  challengeId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RegisterWebauthnCredentialMutation. */
export type RegisterWebauthnCredentialMutationPayload = {
  __typename?: 'RegisterWebauthnCredentialMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<WebauthnCredential>;
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of RemoveEventArtistMutation */
export type RemoveEventArtistMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventArtistId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveEventArtistMutation. */
export type RemoveEventArtistMutationPayload = {
  __typename?: 'RemoveEventArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveEventGroupArtistMutation */
export type RemoveEventGroupArtistMutationInput = {
  /** Artist to remove from every date of the group; with eventGroupId it identifies the entry */
  artistId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Event group of the entry; with artistId it identifies the entry */
  eventGroupId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of RemoveEventGroupArtistMutation. */
export type RemoveEventGroupArtistMutationPayload = {
  __typename?: 'RemoveEventGroupArtistMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveSeatingChartMutation */
export type RemoveSeatingChartMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to remove the chart from */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveSeatingChartMutation. */
export type RemoveSeatingChartMutationPayload = {
  __typename?: 'RemoveSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The updated event */
  event?: Maybe<Event>;
};

/** Autogenerated input type of ReorderEventArtistsMutation */
export type ReorderEventArtistsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventArtistIds: Array<Scalars['Int']['input']>;
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReorderEventArtistsMutation. */
export type ReorderEventArtistsMutationPayload = {
  __typename?: 'ReorderEventArtistsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  eventArtists?: Maybe<Array<EventArtist>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReorderTicketBlueprintsMutation */
export type ReorderTicketBlueprintsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The event whose tickets are reordered */
  eventId: Scalars['Int']['input'];
  /** Ticket ids in their new order; omitted tickets keep their relative order after these */
  ticketBlueprintIds: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of ReorderTicketBlueprintsMutation. */
export type ReorderTicketBlueprintsMutationPayload = {
  __typename?: 'ReorderTicketBlueprintsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the tickets were not reordered */
  errors?: Maybe<Array<VpError>>;
  /** The event tickets in their new order */
  ticketBlueprints?: Maybe<Array<TicketBlueprint>>;
};

/** Autogenerated input type of ResendEmailScheduleMutation */
export type ResendEmailScheduleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailScheduleId: Scalars['Int']['input'];
  recipientEmails: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendEmailScheduleMutation. */
export type ResendEmailScheduleMutationPayload = {
  __typename?: 'ResendEmailScheduleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendOrderConfirmationMutation */
export type ResendOrderConfirmationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the order whose confirmation email should be resent */
  orderId: Scalars['Int']['input'];
};

/** Autogenerated return type of ResendOrderConfirmationMutation. */
export type ResendOrderConfirmationMutationPayload = {
  __typename?: 'ResendOrderConfirmationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** Indicates if the confirmation email was queued */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RevokeApiKeyMutation */
export type RevokeApiKeyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the key to revoke */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RevokeApiKeyMutation. */
export type RevokeApiKeyMutationPayload = {
  __typename?: 'RevokeApiKeyMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that prevented revocation */
  errors?: Maybe<Array<VpError>>;
  /** Whether the key was revoked */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RotateApiKeyMutation */
export type RotateApiKeyMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the key to rotate */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of RotateApiKeyMutation. */
export type RotateApiKeyMutationPayload = {
  __typename?: 'RotateApiKeyMutationPayload';
  /** The replacement API key */
  apiKey: ApiKeyFull;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RotateWebhookSubscriptionSecretMutation */
export type RotateWebhookSubscriptionSecretMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription whose signing secret to rotate */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RotateWebhookSubscriptionSecretMutation. */
export type RotateWebhookSubscriptionSecretMutationPayload = {
  __typename?: 'RotateWebhookSubscriptionSecretMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors preventing the rotation, if any */
  errors?: Maybe<Array<VpError>>;
  /** The subscription with its new signing secret, returned only this once */
  webhookSubscription?: Maybe<WebhookSubscriptionFull>;
};

/** Autogenerated input type of SaveAnnounceDetailMutation */
export type SaveAnnounceDetailMutationInput = {
  /** Announce detail attributes to persist */
  announceDetail: AnnounceDetailInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or updating the announce detail of an event */
export type AnnounceDetailInput = {
  /** Whether to announce the event */
  announce?: InputMaybe<Scalars['Boolean']['input']>;
  /** Artists to associate with the announce */
  announceArtists?: InputMaybe<Array<AnnounceArtistInput>>;
  /** When to announce the event */
  announceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Free-text artist names */
  artists?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Attachments to link to the announce */
  attachments?: InputMaybe<Array<AnnounceAttachmentInput>>;
  /** Custom call-to-action button text */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** Categorisation category id */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Announce description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to announce */
  eventId: Scalars['Int']['input'];
  /** Public name of the event */
  eventName: Scalars['String']['input'];
  /** Facebook URL */
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of an existing announce detail to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Image URLs */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Instagram URL */
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  /** When tickets go on sale */
  onSaleAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Promoter name */
  promoter?: InputMaybe<Scalars['String']['input']>;
  /** Categorisation subcategory id */
  subcategoryId?: InputMaybe<Scalars['String']['input']>;
  /** Support act details */
  support?: InputMaybe<Scalars['String']['input']>;
  /** Tags for the announce */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom tickets URL */
  ticketsUrl?: InputMaybe<Scalars['String']['input']>;
  /** Source of the tickets URL */
  ticketsUrlType?: InputMaybe<TicketsUrlTypeEnum>;
  /** Conversion tracking providers */
  tracking?: InputMaybe<Array<TrackingAttributes>>;
  /** When the announce was triggered */
  triggeredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Twitter URL */
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  /** Categorisation type id */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** An artist to associate with the announce detail */
export type AnnounceArtistInput = {
  /** Apple Music URL */
  applemusic?: InputMaybe<Scalars['String']['input']>;
  /** Bandcamp URL */
  bandcamp?: InputMaybe<Scalars['String']['input']>;
  /** Facebook URL */
  facebook?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of an existing announce artist to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Instagram URL */
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** Last.fm URL */
  lastfm?: InputMaybe<Scalars['String']['input']>;
  /** Name of the artist */
  name: Scalars['String']['input'];
  /** Songkick URL */
  songkick?: InputMaybe<Scalars['String']['input']>;
  /** Spotify URL */
  spotify?: InputMaybe<Scalars['String']['input']>;
  /** Twitter URL */
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** Website URL */
  website?: InputMaybe<Scalars['String']['input']>;
  /** Wikipedia URL */
  wikipedia?: InputMaybe<Scalars['String']['input']>;
  /** YouTube URL */
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** An attachment to link to the announce detail */
export type AnnounceAttachmentInput = {
  /** Remove this attachment link when true */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the attachment to link */
  attachmentId: Scalars['Int']['input'];
  /** Whether the attachment is highlighted */
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attributes for a conversion tracking provider on an announce detail */
export type TrackingAttributes = {
  /** Remove this tracking provider when true */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of an existing tracking provider entry to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The tracking provider */
  provider: TrackingProviderEnum;
  /** The provider-specific tracking identifier */
  trackingId: Scalars['String']['input'];
};

/** Autogenerated return type of SaveAnnounceDetailMutation. */
export type SaveAnnounceDetailMutationPayload = {
  __typename?: 'SaveAnnounceDetailMutationPayload';
  /** The saved announce detail */
  announceDetail?: Maybe<AnnounceDetail>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** Whether the announce detail was saved */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveArtistMutation */
export type SaveArtistMutationInput = {
  /** Attributes for the artist to be saved */
  artist: ArtistInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveArtistMutation. */
export type SaveArtistMutationPayload = {
  __typename?: 'SaveArtistMutationPayload';
  /** The artist that was created or updated */
  artist?: Maybe<Artist>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors encountered while saving the artist */
  errors?: Maybe<Array<VpError>>;
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveDefaultSetMutation */
export type SaveDefaultSetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Default set attributes to persist */
  defaultSet: DefaultSetAttributes;
  /** Venue whose default set to save */
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes to create or update a default set */
export type DefaultSetAttributes = {
  /** Default values */
  defaults: Scalars['JSON']['input'];
  /** Id of the default set to update */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SaveDefaultSetMutation. */
export type SaveDefaultSetMutationPayload = {
  __typename?: 'SaveDefaultSetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The saved default set (nil when deleted) */
  defaultSet?: Maybe<DefaultSet>;
  /** Validation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** Whether the default set was saved */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveDiscountMutation */
export type SaveDiscountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discount: DiscountAttributes;
};

/** Attributes to create or update a discount */
export type DiscountAttributes = {
  /** Discount amount, either a fixed amount ($) or a percentage (%) */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Code customers enter to redeem the discount */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Id of the event the discount belongs to */
  eventId: Scalars['Int']['input'];
  /** When the discount expires */
  expiration?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Id of the discount */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Joinit membership type the discount is tied to */
  joinitMembershipType?: InputMaybe<Scalars['String']['input']>;
  /** Percentage or fixed; pair with numericAmount */
  kind?: InputMaybe<DiscountKindEnum>;
  /** Maximum number of times the discount can be used */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the discount never expires */
  noExpiration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Discount value as a number, paired with kind */
  numericAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Ids of the ticket blueprints the discount applies to */
  ticketBlueprintIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Whether the discount can be used an unlimited number of times */
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SaveDiscountMutation. */
export type SaveDiscountMutationPayload = {
  __typename?: 'SaveDiscountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveEmailScheduleMutation */
export type SaveEmailScheduleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailSchedule: EmailScheduleAttributes;
};

/** Attributes to create or update an email schedule */
export type EmailScheduleAttributes = {
  /** 'Bcc' field list of emails */
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 'Cc' field list of emails */
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Days of the week to send on */
  daysOfWeek?: InputMaybe<Array<DayOfWeekEnum>>;
  /** Type of email to schedule */
  emailType: EmailScheduleEmailTypeEnum;
  /** Last date the schedule is active */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Id of the event */
  eventId: Scalars['Int']['input'];
  /** Hour of the day to send the email at, in the venue timezone */
  hour: Scalars['Int']['input'];
  /** Id of the email schedule */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Minute of the hour to send the email at, in the venue timezone */
  minute: Scalars['Int']['input'];
  /** First date the schedule is active */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** 'To' field list of emails */
  to?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of SaveEmailScheduleMutation. */
export type SaveEmailScheduleMutationPayload = {
  __typename?: 'SaveEmailScheduleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSchedule?: Maybe<EmailSchedule>;
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveEmailTemplateMutation */
export type SaveEmailTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailTemplate: EmailTemplateAttributes;
};

export type EmailTemplateAttributes = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
  templateType: EmailTemplateTypeEnum;
};

/** Autogenerated return type of SaveEmailTemplateMutation. */
export type SaveEmailTemplateMutationPayload = {
  __typename?: 'SaveEmailTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors?: Maybe<Array<VpError>>;
};

/** Autogenerated input type of SaveEventMutation */
export type SaveEventMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: EventInput;
};

/** Autogenerated return type of SaveEventMutation. */
export type SaveEventMutationPayload = {
  __typename?: 'SaveEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  event?: Maybe<Event>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEventArtistRiderMutation */
export type SaveEventArtistRiderMutationInput = {
  /** ID of the artist on the event */
  artistId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Dressing-room curfew for this date. Send null to clear it; omit the argument to leave it unchanged. */
  dressingRoomCurfew?: InputMaybe<Scalars['Time']['input']>;
  /** ID of the event */
  eventId: Scalars['Int']['input'];
  /** Whether this artist headlines this date (co-headliners allowed). Omit the argument to leave it unchanged; null is rejected. */
  headliner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Off-stage (set end) time for the event artist. Send null to clear it; omit the argument to leave it unchanged. */
  offStage?: InputMaybe<Scalars['Time']['input']>;
  /** On-stage (set start) time for the event artist. Send null to clear it; omit the argument to leave it unchanged. */
  onStage?: InputMaybe<Scalars['Time']['input']>;
  /** Rider details to save */
  rider: EventArtistRiderInput;
};

/** Rider details to create or update for an event artist */
export type EventArtistRiderInput = {
  /** Artist load-in time */
  artistLoadInTime?: InputMaybe<Scalars['String']['input']>;
  /** Attachments for the rider */
  attachments?: InputMaybe<Array<EventArtistRiderAttachmentInput>>;
  /** Number of backstage passes */
  backstagePassesNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Rider ID, required for update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Rider notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Rider type */
  riderType?: InputMaybe<EventArtistRiderTypeEnum>;
  /** Sound check type */
  soundCheckType?: InputMaybe<Scalars['String']['input']>;
  /** Number of stage performers */
  stagePerformersNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Stage sound check time */
  stageSoundCheckTime?: InputMaybe<Scalars['String']['input']>;
};

/** An attachment to associate with or remove from a rider */
export type EventArtistRiderAttachmentInput = {
  /** Mark this attachment for destruction */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachment ID */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of SaveEventArtistRiderMutation. */
export type SaveEventArtistRiderMutationPayload = {
  __typename?: 'SaveEventArtistRiderMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors if the save failed */
  errors?: Maybe<Scalars['JSON']['output']>;
  /** The saved rider */
  rider?: Maybe<EventArtistRider>;
  /** Whether the rider was saved successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveGuestListMutation */
export type SaveGuestListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the guest list to save */
  guestList: GuestListAttributes;
};

/** Attributes to create or update a guest list. Omitted fields are left unchanged on update */
export type GuestListAttributes = {
  /** Entries to add, update or remove. Entries not listed are left unchanged, and a row with every field blank is ignored */
  entries?: InputMaybe<Array<GuestListEntryAttributes>>;
  /** ID of the event the list belongs to */
  eventId: Scalars['Int']['input'];
  /** ID of the guest list to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the list, unique within the event; required on create */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An entry to add, update or remove. Omitted fields are left unchanged on update */
export type GuestListEntryAttributes = {
  /** First name of the guest */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the entry to update or remove; omit to add */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Last name of the guest */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Admissions the guest is allowed; at least 1 and never below the claimed count */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** True removes the entry; requires id */
  remove?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SaveGuestListMutation. */
export type SaveGuestListMutationPayload = {
  __typename?: 'SaveGuestListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the guest list was not saved */
  errors?: Maybe<Array<VpError>>;
  /** The saved guest list */
  guestList?: Maybe<GuestList>;
};

/** Autogenerated input type of SaveLabelMutation */
export type SaveLabelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  label: LabelAttributes;
};

export type LabelAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveLabelMutation. */
export type SaveLabelMutationPayload = {
  __typename?: 'SaveLabelMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  label?: Maybe<Label>;
};

/** Autogenerated input type of SaveMemoMutation */
export type SaveMemoMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Memo attributes to persist */
  memo: MemoAttributes;
};

/** Attributes for creating or updating a memo */
export type MemoAttributes = {
  /** Free-text description of the memo */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Last day the memo covers */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Memo category; one of note, out_of_office, holiday, delivery, maintenance */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Memo id (omit to create) */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** First day the memo covers */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Title of the memo */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveMemoMutation. */
export type SaveMemoMutationPayload = {
  __typename?: 'SaveMemoMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors, if any */
  errors?: Maybe<Array<VpError>>;
  /** The saved memo (nil on validation failure) */
  memo?: Maybe<Memo>;
};

/** Autogenerated input type of SavePresaleMutation */
export type SavePresaleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  presale: PresaleAttributes;
};

/** Attributes to create or update a presale */
export type PresaleAttributes = {
  /** Id of the event the presale belongs to */
  eventId: Scalars['Int']['input'];
  /** Id of the presale to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the presale */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional password required to access the presale */
  password?: InputMaybe<Scalars['String']['input']>;
  /** When the presale stops selling */
  sellEnd: Scalars['ISO8601DateTime']['input'];
  /** When the presale starts selling */
  sellStart: Scalars['ISO8601DateTime']['input'];
  /** Whether to show upcoming info for the presale */
  showUpcomingInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ids of the ticket blueprints sold in this presale */
  ticketBlueprintIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated return type of SavePresaleMutation. */
export type SavePresaleMutationPayload = {
  __typename?: 'SavePresaleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  presale?: Maybe<Presale>;
};

/** Autogenerated input type of SaveSettlementCustomExpensesMutation */
export type SaveSettlementCustomExpensesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The full expense lines */
  customExpenses: Array<SettlementCustomExpenseInput>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
};

/** A custom expense line to create, update or remove on an artist settlement */
export type SettlementCustomExpenseInput = {
  /** Marks the expense for removal on save */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount of the custom expense */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Deducted from net or gross */
  deductedType?: InputMaybe<CustomExpenseDeductedTypeEnum>;
  /** Description of the custom expense */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Party the expense is due to */
  due?: InputMaybe<CustomExpenseDueEnum>;
  /** ID of the expense line to update or remove */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SaveSettlementCustomExpensesMutation. */
export type SaveSettlementCustomExpensesMutationPayload = {
  __typename?: 'SaveSettlementCustomExpensesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveSettlementDealsMutation */
export type SaveSettlementDealsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The full deals collection */
  deals: Array<SettlementDealInput>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
};

/** A deal line to create, update or remove on an artist settlement */
export type SettlementDealInput = {
  /** Marks the deal for removal on save */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flat amount for the deal */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Underlying deal template ID; derives dealType when absent */
  dealId?: InputMaybe<Scalars['Int']['input']>;
  /** Deal structure key */
  dealType?: InputMaybe<DealEnum>;
  /** Expense amount applied to the deal */
  expenseAmount?: InputMaybe<Scalars['Float']['input']>;
  /** First-threshold amount for the deal */
  firstAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Hit-threshold amount for the deal */
  hitAmount?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the deal line to update or remove */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Percentage for the deal */
  percent?: InputMaybe<Scalars['Float']['input']>;
  /** Whether to show ticket sales for the deal */
  showTicketSales?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SaveSettlementDealsMutation. */
export type SaveSettlementDealsMutationPayload = {
  __typename?: 'SaveSettlementDealsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveSettlementEventsMutation */
export type SaveSettlementEventsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the events the settlement is based on */
  eventIds: Array<Scalars['Int']['input']>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
};

/** Autogenerated return type of SaveSettlementEventsMutation. */
export type SaveSettlementEventsMutationPayload = {
  __typename?: 'SaveSettlementEventsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveSettlementManualTicketSalesMutation */
export type SaveSettlementManualTicketSalesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
  /** The sale lines */
  manualTicketSales: Array<SettlementManualTicketSaleInput>;
  /** How the settlement is calculated */
  settlementType?: InputMaybe<SettlementTypeEnum>;
};

/** A manual ticket-sale line to create, update or remove on an artist settlement */
export type SettlementManualTicketSaleInput = {
  /** Marks the manual ticket sale for removal on save */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the manual ticket sale */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the manual ticket sale to update or remove */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Price per ticket */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Number of tickets sold */
  ticketsSold?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SaveSettlementManualTicketSalesMutation. */
export type SaveSettlementManualTicketSalesMutationPayload = {
  __typename?: 'SaveSettlementManualTicketSalesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveSettlementPaymentsMutation */
export type SaveSettlementPaymentsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
  /** The full payments collection */
  payments: Array<SettlementPaymentInput>;
};

/** A payment line to create, update or remove on an artist settlement */
export type SettlementPaymentInput = {
  /** Marks the payment for removal on save */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount of the payment */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Check or wire reference number */
  checkWireNr?: InputMaybe<Scalars['String']['input']>;
  /** Date the payment is due */
  dateDue?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Date the payment was made */
  datePaid?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Description of the payment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the payment line to update or remove */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Who the payment is made out to */
  payee?: InputMaybe<Scalars['String']['input']>;
  /** Method of payment */
  paymentType?: InputMaybe<PaymentTypeEnum>;
};

/** Autogenerated return type of SaveSettlementPaymentsMutation. */
export type SaveSettlementPaymentsMutationPayload = {
  __typename?: 'SaveSettlementPaymentsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveSettlementTaxDetailsMutation */
export type SaveSettlementTaxDetailsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the settlement to update */
  id: Scalars['Int']['input'];
  /** The tax section to write */
  taxDetails: SettlementTaxDetailsInput;
};

/** The tax, business and payee-address section of a settlement */
export type SettlementTaxDetailsInput = {
  /** Payee address for the settlement */
  address?: InputMaybe<AddressAttributes>;
  /** Business name on the settlement */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** How the settlement is calculated */
  settlementType?: InputMaybe<SettlementTypeEnum>;
  /** Tax identifier on the settlement */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Label for the tax withholding */
  taxLabel?: InputMaybe<Scalars['String']['input']>;
  /** Tax withholding amount */
  taxWithholdingAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Tax withholding type */
  taxWithholdingType?: InputMaybe<SettlementTaxWithholdingTypeEnum>;
};

export type AddressAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveSettlementTaxDetailsMutation. */
export type SaveSettlementTaxDetailsMutationPayload = {
  __typename?: 'SaveSettlementTaxDetailsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  settlement?: Maybe<Settlement>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveTeamRoleMutation */
export type SaveTeamRoleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamRole: TeamRoleAttributes;
};

/** Attributes for creating or updating a team role */
export type TeamRoleAttributes = {
  /** ID of the team role to update; omit to create a new one */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the team role */
  name: Scalars['String']['input'];
  /** Permission levels and allowances for the role */
  permissionAttributes: PermissionAttributes;
};

/** Permission levels and allowances for a team role */
export type PermissionAttributes = {
  add_artist?: InputMaybe<Scalars['Boolean']['input']>;
  add_hold?: InputMaybe<Scalars['Boolean']['input']>;
  artists__financials?: InputMaybe<Scalars['String']['input']>;
  artists__hospitality_rider?: InputMaybe<Scalars['String']['input']>;
  artists__stats_sheet?: InputMaybe<Scalars['String']['input']>;
  artists__tech_rider?: InputMaybe<Scalars['String']['input']>;
  box_office_app?: InputMaybe<Scalars['Boolean']['input']>;
  budget__actual_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__actual_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__actual_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__projected_concessions?: InputMaybe<Scalars['String']['input']>;
  budget__projected_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__projected_incomes?: InputMaybe<Scalars['String']['input']>;
  budget__shared_expenses?: InputMaybe<Scalars['String']['input']>;
  budget__summary?: InputMaybe<Scalars['String']['input']>;
  budget__template?: InputMaybe<Scalars['String']['input']>;
  cancel_event?: InputMaybe<Scalars['Boolean']['input']>;
  closeout_sheet__access?: InputMaybe<Scalars['String']['input']>;
  closeout_sheet__manual_tickets?: InputMaybe<Scalars['String']['input']>;
  confirm_date?: InputMaybe<Scalars['Boolean']['input']>;
  customers__credits?: InputMaybe<Scalars['String']['input']>;
  download_will_call?: InputMaybe<Scalars['Boolean']['input']>;
  event_details__announce?: InputMaybe<Scalars['String']['input']>;
  event_details__audit_log?: InputMaybe<Scalars['String']['input']>;
  event_details__canceled_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__confirmed_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__deleted_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__hold_dates?: InputMaybe<Scalars['String']['input']>;
  event_details__name?: InputMaybe<Scalars['String']['input']>;
  event_details__notes?: InputMaybe<Scalars['String']['input']>;
  other__artists?: InputMaybe<Scalars['String']['input']>;
  other__event_notes?: InputMaybe<Scalars['String']['input']>;
  other__memos?: InputMaybe<Scalars['String']['input']>;
  other__orders?: InputMaybe<Scalars['String']['input']>;
  other__projections?: InputMaybe<Scalars['String']['input']>;
  prism_fm?: InputMaybe<Scalars['Boolean']['input']>;
  reports__by_day?: InputMaybe<Scalars['String']['input']>;
  reports__by_email_opt_ins?: InputMaybe<Scalars['String']['input']>;
  reports__by_event_cancelation?: InputMaybe<Scalars['String']['input']>;
  reports__by_payment?: InputMaybe<Scalars['String']['input']>;
  sales_info__fees?: InputMaybe<Scalars['String']['input']>;
  sales_info__gbor?: InputMaybe<Scalars['String']['input']>;
  sales_info__number_sold?: InputMaybe<Scalars['String']['input']>;
  settings__integrations?: InputMaybe<Scalars['String']['input']>;
  settings__privileges?: InputMaybe<Scalars['String']['input']>;
  settings__team?: InputMaybe<Scalars['String']['input']>;
  settings__venues?: InputMaybe<Scalars['String']['input']>;
  settings__webhooks?: InputMaybe<Scalars['String']['input']>;
  ticketing__guest_list?: InputMaybe<Scalars['String']['input']>;
  ticketing__tickets?: InputMaybe<Scalars['String']['input']>;
  ticketing__will_call?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveTeamRoleMutation. */
export type SaveTeamRoleMutationPayload = {
  __typename?: 'SaveTeamRoleMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  teamRole?: Maybe<TeamRoleDetails>;
};

/** Autogenerated input type of SaveTicketBlueprintMutation */
export type SaveTicketBlueprintMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the ticket to save */
  ticketBlueprint: TicketBlueprintAttributes;
};

/** Autogenerated return type of SaveTicketBlueprintMutation. */
export type SaveTicketBlueprintMutationPayload = {
  __typename?: 'SaveTicketBlueprintMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the ticket was not saved */
  errors?: Maybe<Array<VpError>>;
  /** The saved ticket */
  ticketBlueprint?: Maybe<TicketBlueprint>;
};

/** Autogenerated input type of SaveTicketHoldMutation */
export type SaveTicketHoldMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the hold to save */
  ticketHold: TicketHoldAttributes;
};

/** Attributes to create or update a ticket hold. Omitted fields are left unchanged on update */
export type TicketHoldAttributes = {
  /** ID of the event the hold belongs to, also on update */
  eventId: Scalars['Int']['input'];
  /** ID of the hold to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the hold; required on create, unique among the event's tickets and holds */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tickets held back from sale; 0 when omitted on create */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Ticket whose allotment this hold draws from; required on create */
  sourceTicketId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SaveTicketHoldMutation. */
export type SaveTicketHoldMutationPayload = {
  __typename?: 'SaveTicketHoldMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the hold was not saved */
  errors?: Maybe<Array<VpError>>;
  /** The saved hold */
  ticketHold?: Maybe<TicketHold>;
};

/** Autogenerated input type of SaveTicketSectionMutation */
export type SaveTicketSectionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the section to save */
  ticketSection: TicketSectionAttributes;
};

/** Attributes to create or update a ticket section. Omitted fields are left unchanged on update */
export type TicketSectionAttributes = {
  /** Hex colour, #RGB or #RRGGBB; #001D3B when omitted on create */
  color?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event the section belongs to, also on update */
  eventId: Scalars['Int']['input'];
  /** ID of the section to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Display name of the section, unique among the event's sections */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Tickets the section can sell; required on create, greater than zero and not below what the section has already sold */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SaveTicketSectionMutation. */
export type SaveTicketSectionMutationPayload = {
  __typename?: 'SaveTicketSectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the section was not saved */
  errors?: Maybe<Array<VpError>>;
  /** The saved section */
  ticketSection?: Maybe<TicketSection>;
};

/** Autogenerated input type of SaveUserMutation */
export type SaveUserMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  user: UserAttributes;
};

export type UserAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveUserMutation. */
export type SaveUserMutationPayload = {
  __typename?: 'SaveUserMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  user?: Maybe<User>;
};

/** Autogenerated input type of SaveUserAccountMutation */
export type SaveUserAccountMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccount: UserAccountAttributes;
};

/** Attributes for creating or updating a user account (team member) */
export type UserAccountAttributes = {
  /** ID of the user account to update; omit to create a new one */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Team role to assign to the member */
  teamRoleId: Scalars['Int']['input'];
  /** User details, used when inviting a new member */
  user?: InputMaybe<UserAttributes>;
};

/** Autogenerated return type of SaveUserAccountMutation. */
export type SaveUserAccountMutationPayload = {
  __typename?: 'SaveUserAccountMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  userAccount?: Maybe<UserAccount>;
};

/** Autogenerated input type of SaveVenueMutation */
export type SaveVenueMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venue: VenueAttributes;
};

export type VenueAttributes = {
  address?: InputMaybe<AddressAttributes>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeCcFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeConvenienceFee?: InputMaybe<Scalars['Boolean']['input']>;
  includeTaxFee?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  processingFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  rooms?: InputMaybe<Array<VenueRoomAttributes>>;
  salesTax?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type VenueRoomAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveVenueMutation. */
export type SaveVenueMutationPayload = {
  __typename?: 'SaveVenueMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of SaveWidgetMutation */
export type SaveWidgetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  widget: WidgetAttributes;
};

/** Attributes to create or update a widget configuration */
export type WidgetAttributes = {
  /** Widget configuration payload */
  configuration?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable description of the widget configuration */
  description: Scalars['String']['input'];
  /** Id of the widget configuration to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** URL of the widget loader script */
  loaderUrl: Scalars['String']['input'];
  /** Custom styling for the widget */
  style?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveWidgetMutation. */
export type SaveWidgetMutationPayload = {
  __typename?: 'SaveWidgetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  widget?: Maybe<WidgetConfig>;
};

/** Autogenerated input type of SelectSeatingChartMutation */
export type SelectSeatingChartMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event to assign the chart to */
  eventId: Scalars['Int']['input'];
  /** ID of the seating chart to assign */
  seatingChartId: Scalars['Int']['input'];
};

/** Autogenerated return type of SelectSeatingChartMutation. */
export type SelectSeatingChartMutationPayload = {
  __typename?: 'SelectSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The updated event */
  event?: Maybe<Event>;
};

/** Autogenerated input type of SendUserAccountInvitationMutation */
export type SendUserAccountInvitationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccountId: Scalars['Int']['input'];
};

/** Autogenerated return type of SendUserAccountInvitationMutation. */
export type SendUserAccountInvitationMutationPayload = {
  __typename?: 'SendUserAccountInvitationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendWillCallEmailsMutation */
export type SendWillCallEmailsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  willCallEmails: WillCallEmailAttributes;
};

export type WillCallEmailAttributes = {
  bccEmails: Array<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  resendTickets?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
  ticketBlueprintId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SendWillCallEmailsMutation. */
export type SendWillCallEmailsMutationPayload = {
  __typename?: 'SendWillCallEmailsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetEventLabelsMutation */
export type SetEventLabelsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  eventLabels: Array<LabelAssignmentAttributes>;
};

export type LabelAssignmentAttributes = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  labelId: Scalars['Int']['input'];
};

/** Autogenerated return type of SetEventLabelsMutation. */
export type SetEventLabelsMutationPayload = {
  __typename?: 'SetEventLabelsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetFeaturePreviewMutation */
export type SetFeaturePreviewMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to enable or disable the feature. */
  enabled: Scalars['Boolean']['input'];
  /** The feature to enable or disable. */
  feature: Scalars['String']['input'];
};

/** Autogenerated return type of SetFeaturePreviewMutation. */
export type SetFeaturePreviewMutationPayload = {
  __typename?: 'SetFeaturePreviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetUserAccountLabelsMutation */
export type SetUserAccountLabelsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userAccountId: Scalars['Int']['input'];
  userAccountLabels: Array<LabelAssignmentAttributes>;
};

/** Autogenerated return type of SetUserAccountLabelsMutation. */
export type SetUserAccountLabelsMutationPayload = {
  __typename?: 'SetUserAccountLabelsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetWebhookSubscriptionDeliveryMutation */
export type SetWebhookSubscriptionDeliveryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the subscription should deliver */
  enabled: Scalars['Boolean']['input'];
  /** The subscription to switch */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetWebhookSubscriptionDeliveryMutation. */
export type SetWebhookSubscriptionDeliveryMutationPayload = {
  __typename?: 'SetWebhookSubscriptionDeliveryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why delivery did not resume, if it did not */
  errors?: Maybe<Array<VpError>>;
  /** The subscription as switched */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Autogenerated input type of SigninWithPasskeyMutation */
export type SigninWithPasskeyMutationInput = {
  assertionResponseJson: Scalars['String']['input'];
  challengeId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SigninWithPasskeyMutation. */
export type SigninWithPasskeyMutationPayload = {
  __typename?: 'SigninWithPasskeyMutationPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  returnTo?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SyncArtistMutation */
export type SyncArtistMutationInput = {
  /** ID of the artist to sync */
  artistId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SyncArtistMutation. */
export type SyncArtistMutationPayload = {
  __typename?: 'SyncArtistMutationPayload';
  /** The synced artist */
  artist?: Maybe<Artist>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SyncPrismSalesMutation */
export type SyncPrismSalesMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** VenuePilot event ID to sync sales for */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of SyncPrismSalesMutation. */
export type SyncPrismSalesMutationPayload = {
  __typename?: 'SyncPrismSalesMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** Whether the operation succeeded */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncSeatingChartMutation */
export type SyncSeatingChartMutationInput = {
  /** The seats.io chart key to sync */
  chartKey: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SyncSeatingChartMutation. */
export type SyncSeatingChartMutationPayload = {
  __typename?: 'SyncSeatingChartMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors if the operation failed */
  errors?: Maybe<Array<VpError>>;
  /** The synced seating chart */
  seatingChart?: Maybe<SeatingChart>;
};

/** Autogenerated input type of TakeWebhookSubscriptionOwnershipMutation */
export type TakeWebhookSubscriptionOwnershipMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription to take ownership of */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TakeWebhookSubscriptionOwnershipMutation. */
export type TakeWebhookSubscriptionOwnershipMutationPayload = {
  __typename?: 'TakeWebhookSubscriptionOwnershipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the member's own access does not cover it */
  errors?: Maybe<Array<VpError>>;
  /** The subscription under its new principal */
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Autogenerated input type of TriggerArtistZapierMutation */
export type TriggerArtistZapierMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event artist to trigger the Zapier push for */
  eventArtistId: Scalars['Int']['input'];
};

/** Autogenerated return type of TriggerArtistZapierMutation. */
export type TriggerArtistZapierMutationPayload = {
  __typename?: 'TriggerArtistZapierMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the Zapier push was triggered successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TriggerEventArtistZapierMutation */
export type TriggerEventArtistZapierMutationInput = {
  /** ID of the artist to trigger the Zapier push for */
  artistId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event the artist is on */
  eventId: Scalars['Int']['input'];
};

/** Autogenerated return type of TriggerEventArtistZapierMutation. */
export type TriggerEventArtistZapierMutationPayload = {
  __typename?: 'TriggerEventArtistZapierMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the Zapier push was triggered successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateSheetMutation */
export type UpdateSheetMutationInput = {
  /** Billing terms for the offer */
  billing?: InputMaybe<Scalars['String']['input']>;
  /** Deal figures to reset to empty; a null deal figure argument is ignored */
  clearDealFigures?: InputMaybe<Array<DealFigureEnum>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Guaranteed amount paid to the artist */
  dealArtistGuarantee?: InputMaybe<Scalars['Float']['input']>;
  /** Artist percentage of gross box office revenue */
  dealGborPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Deal structure for the offer */
  dealType?: InputMaybe<DealEnum>;
  /** Doors-open time */
  doorTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Show end time */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Exclusivity terms for the offer */
  exclusivity?: InputMaybe<Scalars['String']['input']>;
  /** Guaranteed amount paid to the headliner */
  headlinerGuarantee?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the offer sheet to update */
  id: Scalars['Int']['input'];
  /** Merchandise terms for the offer */
  merch?: InputMaybe<Scalars['String']['input']>;
  /** Minimum attendee age for the event */
  minimumAge?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the offer sheet */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Free-form note on the offer */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Date the offer expires */
  offerExpirationDate?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable summary of performance dates */
  performanceDatesDescription?: InputMaybe<Scalars['String']['input']>;
  /** Name of the promoter */
  promoterName?: InputMaybe<Scalars['String']['input']>;
  /** Promoter profit percentage */
  promoterProfitPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Show start time */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Support act terms for the offer */
  support?: InputMaybe<Scalars['String']['input']>;
  /** Guaranteed amount paid to the support act */
  supportGuarantee?: InputMaybe<Scalars['Float']['input']>;
  /** Tax percentage applied to the offer */
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Numeric deal figure on an offer sheet that updateOfferSheet can clear */
export enum DealFigureEnum {
  /** Guaranteed amount paid to the artist */
  DealArtistGuarantee = 'deal_artist_guarantee',
  /** Artist percentage of gross box office revenue */
  DealGborPercentage = 'deal_gbor_percentage',
  /** Guaranteed amount paid to the headliner */
  HeadlinerGuarantee = 'headliner_guarantee',
  /** Guaranteed amount paid to the support act */
  SupportGuarantee = 'support_guarantee'
}

/** Autogenerated return type of UpdateSheetMutation. */
export type UpdateSheetMutationPayload = {
  __typename?: 'UpdateSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpdateOrderCustomerMutation */
export type UpdateOrderCustomerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the order whose contact is being updated */
  orderId: Scalars['Int']['input'];
  /** Customer contact fields to apply to the order */
  updateOrderCustomerInput: UpdateOrderCustomerInput;
};

/** Customer contact fields to set on an order */
export type UpdateOrderCustomerInput = {
  /** Customer email address */
  email: Scalars['String']['input'];
  /** Customer first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Customer last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Customer phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOrderCustomerMutation. */
export type UpdateOrderCustomerMutationPayload = {
  __typename?: 'UpdateOrderCustomerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  /** The order with the updated contact */
  order?: Maybe<Order>;
};

/** Autogenerated input type of UpdateWebhookSubscriptionMutation */
export type UpdateWebhookSubscriptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The absolute HTTPS URL deliveries are POSTed to */
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  /** The subscription to update */
  id: Scalars['ID']['input'];
  /** Deliver hold events to this subscription (operator opt-in) */
  includeHolds?: InputMaybe<Scalars['Boolean']['input']>;
  /** The topics to subscribe to */
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateWebhookSubscriptionMutation. */
export type UpdateWebhookSubscriptionMutationPayload = {
  __typename?: 'UpdateWebhookSubscriptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  webhookSubscription?: Maybe<WebhookSubscription>;
};

/** Autogenerated input type of UpsertContactMutation */
export type UpsertContactMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the contact */
  email: Scalars['String']['input'];
  /** ID of the contact to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the contact */
  name: Scalars['String']['input'];
  /** ID of the offer sheet the contact belongs to */
  offerSheetId: Scalars['Int']['input'];
  /** Role of the contact on the offer */
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertContactMutation. */
export type UpsertContactMutationPayload = {
  __typename?: 'UpsertContactMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<OfferSheetContact>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertExpenseMutation */
export type UpsertExpenseMutationInput = {
  /** Monetary amount of the expense */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** How a variable expense is calculated */
  calculationType?: InputMaybe<VariableExpenseEnum>;
  /** Value used by the calculation type */
  calculationValue?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the category the expense belongs to */
  expenseCategoryId: Scalars['Int']['input'];
  /** ID of the expense to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the expense */
  name: Scalars['String']['input'];
  /** ID of the offer sheet the expense belongs to */
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertExpenseMutation. */
export type UpsertExpenseMutationPayload = {
  __typename?: 'UpsertExpenseMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  expense?: Maybe<Expense>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertExpenseCategoryMutation */
export type UpsertExpenseCategoryMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the expense category to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the expense category */
  name: Scalars['String']['input'];
  /** ID of the offer sheet the category belongs to */
  offerSheetId: Scalars['Int']['input'];
  /** Whether this category holds variable expenses */
  variable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpsertExpenseCategoryMutation. */
export type UpsertExpenseCategoryMutationPayload = {
  __typename?: 'UpsertExpenseCategoryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  expenseCategory?: Maybe<ExpenseCategory>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertListMutation */
export type UpsertListMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Projected gross revenue for the list */
  gross?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the list to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Type of the list */
  listType: ListTypeEnum;
  /** Name of the list */
  name: Scalars['String']['input'];
  /** ID of the offer sheet the list belongs to */
  offerSheetId: Scalars['Int']['input'];
  /** Projected number of attendees on the list */
  projected: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertListMutation. */
export type UpsertListMutationPayload = {
  __typename?: 'UpsertListMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  list?: Maybe<List>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertAgentMutation */
export type UpsertAgentMutationInput = {
  /** Name of the agency the agent represents */
  agencyName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the agent */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of an existing agent to update */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the agent */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the offer sheet to assign the agent to */
  offerSheetId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpsertAgentMutation. */
export type UpsertAgentMutationPayload = {
  __typename?: 'UpsertAgentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
};

/** Autogenerated input type of UpsertTicketMutation */
export type UpsertTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the ticket to update; omit to create */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the ticket */
  name: Scalars['String']['input'];
  /** ID of the offer sheet the ticket belongs to */
  offerSheetId: Scalars['Int']['input'];
  /** Price per ticket */
  price: Scalars['Float']['input'];
  /** Projected number of tickets sold */
  projected: Scalars['Int']['input'];
  /** Seating section for the ticket */
  section: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertTicketMutation. */
export type UpsertTicketMutationPayload = {
  __typename?: 'UpsertTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<VpError>>;
  sheet?: Maybe<Sheet>;
  ticket?: Maybe<OfferTicket>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    